/**
 * Beaufort API
 * 1.0.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "oazapfts/lib/runtime";
import * as QS from "oazapfts/lib/runtime/query";
export const defaults: Oazapfts.RequestOpts = {
    baseUrl: "/",
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {};
export type CountryEnum = "AW" | "AF" | "AO" | "AI" | "AX" | "AL" | "AD" | "AE" | "AR" | "AM" | "AS" | "AQ" | "TF" | "AG" | "AU" | "AT" | "AZ" | "BI" | "BE" | "BJ" | "BQ" | "BF" | "BD" | "BG" | "BH" | "BS" | "BA" | "BL" | "BY" | "BZ" | "BM" | "BO" | "BR" | "BB" | "BN" | "BT" | "BV" | "BW" | "CF" | "CA" | "CC" | "CH" | "CL" | "CN" | "CI" | "CM" | "CD" | "CG" | "CK" | "CO" | "KM" | "CV" | "CR" | "CU" | "CW" | "CX" | "KY" | "CY" | "CZ" | "DE" | "DJ" | "DM" | "DK" | "DO" | "DZ" | "EC" | "EG" | "ER" | "EH" | "ES" | "EE" | "ET" | "FI" | "FJ" | "FK" | "FR" | "FO" | "FM" | "GA" | "GB" | "GE" | "GG" | "GH" | "GI" | "GN" | "GP" | "GM" | "GW" | "GQ" | "GR" | "GD" | "GL" | "GT" | "GF" | "GU" | "GY" | "HK" | "HM" | "HN" | "HR" | "HT" | "HU" | "ID" | "IM" | "IN" | "IO" | "IE" | "IR" | "IQ" | "IS" | "IL" | "IT" | "JM" | "JE" | "JO" | "JP" | "KZ" | "KE" | "KG" | "KH" | "KI" | "KN" | "KR" | "KW" | "LA" | "LB" | "LR" | "LY" | "LC" | "LI" | "LK" | "LS" | "LT" | "LU" | "LV" | "MO" | "MF" | "MA" | "MC" | "MD" | "MG" | "MV" | "MX" | "MH" | "MK" | "ML" | "MT" | "MM" | "ME" | "MN" | "MP" | "MZ" | "MR" | "MS" | "MQ" | "MU" | "MW" | "MY" | "YT" | "NA" | "NC" | "NE" | "NF" | "NG" | "NI" | "NU" | "NL" | "NO" | "NP" | "NR" | "NZ" | "OM" | "PK" | "PA" | "PN" | "PE" | "PH" | "PW" | "PG" | "PL" | "PR" | "KP" | "PT" | "PY" | "PS" | "PF" | "QA" | "RE" | "RO" | "RU" | "RW" | "SA" | "SD" | "SN" | "SG" | "GS" | "SH" | "SJ" | "SB" | "SL" | "SV" | "SM" | "SO" | "PM" | "RS" | "SS" | "ST" | "SR" | "SK" | "SI" | "SE" | "SZ" | "SX" | "SC" | "SY" | "TC" | "TD" | "TG" | "TH" | "TJ" | "TK" | "TM" | "TL" | "TO" | "TT" | "TN" | "TR" | "TV" | "TW" | "TZ" | "UG" | "UA" | "UM" | "UY" | "US" | "UZ" | "VA" | "VC" | "VE" | "VG" | "VI" | "VN" | "VU" | "WF" | "WS" | "YE" | "ZA" | "ZM" | "ZW" | "AN" | "YU" | "XK";
export type GenderEnum = "M" | "F";
export type Address = {
    address_line_1?: string;
    address_line_2?: string;
    postal_code?: string;
    city?: string;
    county?: string;
    country: CountryEnum;
};
export type OnboardingPersonCustomer = {
    first_name: string;
    last_name: string;
    national_id?: string;
    national_id_country?: CountryEnum;
    birth_date?: string;
    birth_year?: number;
    country_of_residence?: CountryEnum;
    country_of_citizenship?: CountryEnum;
    country_of_origin?: CountryEnum;
    country_of_domicile?: CountryEnum;
    gender?: GenderEnum;
    address?: Address;
    phone?: string;
    email?: string;
    external_id?: string;
    extra?: object;
};
export type ScreeningSettings = {
    realtime?: boolean;
    monitoring?: boolean;
};
export type EnrichmentSettings = {
    brreg?: boolean;
    beneficial_owners?: boolean;
};
export type SignatureSettings = {
    create?: boolean;
    send_email?: boolean;
    use_disclosure?: boolean;
    use_verification?: boolean;
    signer_email?: string;
};
export type OnboardingSettings = {
    screening?: ScreeningSettings;
    enrichment?: EnrichmentSettings;
    signature?: SignatureSettings;
};
export type PersonOnboarding = {
    person: OnboardingPersonCustomer;
    settings?: OnboardingSettings;
    responsible_user_email?: string;
};
export type DataServiceSubjectScreeningStatus = {
    screening_type?: string;
    screening_status: string;
    screening_started?: string;
    screening_stopped?: string;
    screening_updated?: string;
    unresolved_cases: number;
    unresolved_cases_ids?: string[];
};
export type DataServiceRiskLevel = "NOT_SET" | "LOW" | "NORMAL" | "HIGH";
export type DataServiceOnboardingStatus = "FETCHING_DATA" | "SCREENING_CONFIG" | "SIGNATURE_CONFIG" | "READY" | "DONE" | "STARTED";
export type DataServiceReviewStatus = "NOT_READY" | "REVIEW_REQUIRED" | "APPROVED" | "REJECTED";
export type DataServiceUser = {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    is_active?: boolean;
    groups?: number[];
};
export type DataServiceProjectStatus = "ACTIVE" | "INACTIVE";
export type TranslationText = {
    nb: string;
    en?: string;
};
export type DataServiceLabelListItem = {
    id: string;
    title: TranslationText;
    read_only: boolean;
    is_assigned?: boolean;
    color?: string;
};
export type DataServiceVitecRole = "SELLER" | "BUYER" | "PROXY" | "ACCOUNT_MANAGER_BUYER" | "ACCOUNT_MANAGER_SELLER" | "SELLERS_SPOUSE" | "HEIR";
export type DataServiceVitecReportStatus = "WAITING" | "COMPLETED" | "FAILED";
export type DataServiceVitecReport = {
    id: string;
    created_dt: string;
    sync_status: DataServiceVitecReportStatus;
    updated_dt: string;
};
export type DataServiceVitecContact = {
    id: string;
    subject_id: string;
    vitec_role: DataServiceVitecRole;
    report?: DataServiceVitecReport;
    proxy_id?: string;
};
export type DataServiceVitecData = {
    id: string;
    vitec_estate_url?: string;
    contacts: DataServiceVitecContact[];
};
export type DataServiceProjectIntegrationData = {
    vitec_data?: DataServiceVitecData;
};
export type DataServiceProjectListItem = {
    id: string;
    name: string;
    status: DataServiceProjectStatus;
    responsible?: DataServiceUser;
    responsible_users?: DataServiceUser[];
    created_dt: string;
    subject_count: number;
    subject_labels?: DataServiceLabelListItem[];
    integrations?: DataServiceProjectIntegrationData;
};
export type DataServiceAssignment = {
    id: string;
    industry_type?: string;
    name: string;
    description: string;
    purpose?: string;
    purpose_desc?: string;
    created_dt: string;
    created_by?: DataServiceUser;
    updated_dt?: string;
    updated_by?: DataServiceUser;
    responsible_users: DataServiceUser[];
    is_accepted?: boolean;
    risk_level?: string;
    signature_count: number;
    completed_signature_count: number;
    is_archived: boolean;
    start_date?: string;
    end_date?: string;
    archived_by?: DataServiceUser;
    archived_dt?: string;
};
export type DataServiceGender = "MALE" | "FEMALE";
export type DataServicePersonDetail = {
    first_name: string;
    last_name: string;
    national_id?: string;
    national_id_country?: string;
    /** A Norwegian phone number. */
    phone?: string;
    country_of_residence?: string;
    country_of_citizenship?: string;
    country_of_origin?: string;
    country_of_domicile?: string;
    birth_date?: string;
    birth_year?: number;
    gender?: DataServiceGender;
    email?: string;
    mailing_address?: Address;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    id: string;
};
export type DataServicePersonSubjectDetailResponse = {
    id: string;
    external_id?: string;
    created_dt?: string;
    screening_status: DataServiceSubjectScreeningStatus;
    risk_level: DataServiceRiskLevel;
    onboarding_status: DataServiceOnboardingStatus;
    review_status: DataServiceReviewStatus;
    pending_measures_count?: number;
    extra?: object;
    responsible?: DataServiceUser;
    responsible_users?: DataServiceUser[];
    is_archived?: boolean;
    archived_by?: DataServiceUser;
    archiving_dt?: string;
    is_manual: boolean;
    projects: DataServiceProjectListItem[];
    labels?: DataServiceLabelListItem[];
    assignments?: DataServiceAssignment[];
    follow_up_date?: string;
    is_follow_up_expired?: boolean;
    has_pending_reviews?: boolean;
    pending_review_id?: string;
    requires_review_approval_by_user?: boolean;
    pending_review_approval_users?: DataServiceUser[];
    pending_review_approval_request_datetime?: string;
    pending_disclosure_count?: number;
    pending_attachment_signature_count?: number;
    draft_review_ids?: string[];
    person: DataServicePersonDetail;
    onboarding_document_url?: string;
    onboarding_document_signed?: boolean;
};
export type DataServiceEnrichmentSources = {
    basic_info?: boolean;
    roles?: boolean;
    beneficial_owners?: boolean;
};
export type DataServiceEnrichmentSettings = {
    sources?: DataServiceEnrichmentSources;
};
export type DataServiceScreeningType = "NOT_SET" | "NONE" | "ONE_TIME" | "MONITORING";
export type DataServiceScreeningSettings = {
    "type"?: DataServiceScreeningType;
};
export type OnboardingSignatureSettingsResponse = {
    create?: boolean;
    send_email?: boolean;
    signer_email?: string;
    use_disclosure?: boolean;
    use_verification?: boolean;
};
export type OnboardingSettingsResponse = {
    enrichment?: DataServiceEnrichmentSettings;
    screening?: DataServiceScreeningSettings;
    signature?: OnboardingSignatureSettingsResponse;
    signature_required?: boolean;
};
export type PersonOnboardingResponse = {
    id: string;
    subject: DataServicePersonSubjectDetailResponse;
    settings: OnboardingSettingsResponse;
};
export type ValidationError = {
    loc: (string | number)[];
    msg: string;
    "type": string;
};
export type HttpValidationError = {
    detail?: ValidationError[];
};
export type CompanyTypeOptions = "AAFY" | "ADOS" | "ANNA" | "ANS" | "AS" | "ASA" | "BA" | "BBL" | "BEDR" | "BO" | "BRL" | "DA" | "ENK" | "EOFG" | "ESEK" | "FKF" | "FLI" | "FYLK" | "GFS" | "IKJP" | "IKS" | "KBO" | "KF" | "KIRK" | "KOMM" | "KS" | "KTRF" | "NUF" | "OPMV" | "ORGL" | "PERS" | "PK" | "PRE" | "SA" | "SAM" | "SE" | "SF" | "SPA" | "STAT" | "STI" | "S\u00C6R" | "TVAM" | "UTLA" | "VIFE" | "VPFO";
export type CompanySectorCodes = "1110" | "1120" | "1510" | "1520" | "2100" | "2300" | "2500" | "3100" | "3200" | "3500" | "3600" | "3900" | "4100" | "4300" | "4500" | "4900" | "5500" | "5700" | "6100" | "6500" | "7000" | "8200" | "8300" | "8500";
export type IndustryCodeEnum = "33.2" | "84.12" | "60.200" | "20.420" | "20.150" | "25.220" | "86.910" | "80.010" | "47.120" | "29" | "00.000" | "93.210" | "01.63" | "78" | "26.60" | "10.71" | "25.62" | "18.12" | "47.62" | "93" | "02.200" | "E" | "41.000" | "69.203" | "17.220" | "79.122" | "64.210" | "46.46" | "69" | "85.401" | "28.23" | "71.110" | "01.160" | "09.10" | "R" | "84.250" | "50.4" | "23.3" | "43.350" | "66.210" | "43.230" | "25.4" | "32.300" | "30.910" | "32.12" | "32.9" | "46.440" | "28.29" | "27.9" | "49.420" | "30.130" | "38.220" | "98.1" | "20.13" | "20.170" | "79" | "28.420" | "87.99" | "47.110" | "50.102" | "88.91" | "27.310" | "43" | "01.460" | "22.250" | "96.30" | "30.2" | "24.10" | "47.551" | "33.20" | "38.32" | "47.730" | "49.32" | "10.201" | "49.39" | "47.23" | "23.41" | "86.22" | "33.190" | "50.109" | "33.140" | "73.110" | "46.240" | "81.22" | "86.941" | "33.130" | "24.5" | "95.210" | "77.39" | "61.90" | "62.9" | "11.010" | "46.45" | "38.110" | "79.1" | "60.3" | "16.28" | "01.452" | "35.110" | "25.610" | "88.104" | "47.9" | "47.720" | "50.300" | "28.12" | "32.400" | "43.330" | "11.050" | "13.300" | "10.510" | "95.23" | "25.910" | "61" | "01.700" | "31.0" | "50.400" | "50.3" | "14.21" | "35.129" | "68.12" | "32.30" | "10.1" | "65.11" | "35.12" | "43.22" | "59.14" | "06.100" | "11.07" | "20.14" | "85.1" | "85.100" | "13.200" | "73.20" | "14.210" | "01.471" | "33.1" | "01" | "13.1" | "59" | "43.99" | "23.99" | "95.240" | "20" | "20.5" | "22.210" | "85.2" | "35" | "85.591" | "07.29" | "24.31" | "87.201" | "23.44" | "43.340" | "53.300" | "25.400" | "86.99" | "84.130" | "96.40" | "82.92" | "02.2" | "46.110" | "20.140" | "32.1" | "95.220" | "95.29" | "47.270" | "27.400" | "81.100" | "56.300" | "11.020" | "33.17" | "33" | "33.170" | "33.11" | "43.24" | "85.692" | "73.3" | "87.9" | "28.93" | "26" | "16.2" | "01.2" | "73" | "46.38" | "35.300" | "74.1" | "96.91" | "11.040" | "47.55" | "46.89" | "26.510" | "55.20" | "17.11" | "84.23" | "64.92" | "33.19" | "16.24" | "64.19" | "77.22" | "15.2" | "46.12" | "94.110" | "91.410" | "18.11" | "28.940" | "86.102" | "75.0" | "32.3" | "20.590" | "24.100" | "90.120" | "38.120" | "87.103" | "42.13" | "66.290" | "28.24" | "24.430" | "85.597" | "46.610" | "27.330" | "28.410" | "47.52" | "43.42" | "68.110" | "95.2" | "10.820" | "46.460" | "50.40" | "77.40" | "84" | "78.10" | "10.840" | "01.7" | "77.1" | "47.27" | "51" | "11.030" | "49" | "91.1" | "10.2" | "85.529" | "46.720" | "35.30" | "42.210" | "21.100" | "10.39" | "65.120" | "13.960" | "66.12" | "38.1" | "42.9" | "01.46" | "21" | "47.640" | "23.32" | "46.370" | "10.84" | "10.310" | "49.3" | "20.60" | "85" | "95.40" | "01.240" | "97.00" | "30.920" | "05" | "65.3" | "25.940" | "16.11" | "08.110" | "32.11" | "28.960" | "59.120" | "94.120" | "66.22" | "27.5" | "23.31" | "46.360" | "47.78" | "85.33" | "47.762" | "20.12" | "03.2" | "46.830" | "28.97" | "26.70" | "82.100" | "33.120" | "03.22" | "23.51" | "58.2" | "68.20" | "47.81" | "58.19" | "17.120" | "51.220" | "09.90" | "13.100" | "25.2" | "43.50" | "23.630" | "29.320" | "32.91" | "43.33" | "08.11" | "18.2" | "86.950" | "90.13" | "62.90" | "43.310" | "46.490" | "13.910" | "01.25" | "28.1" | "23.520" | "15.200" | "28.150" | "46.180" | "24.200" | "23.4" | "46.730" | "18" | "01.12" | "24.43" | "28.110" | "28.92" | "20.4" | "46.8" | "25.620" | "46.470" | "94.9" | "50.30" | "47.552" | "23.440" | "19.1" | "23.610" | "21.2" | "95.31" | "35.15" | "20.42" | "10.730" | "43.5" | "20.15" | "86" | "52.219" | "91.220" | "28.230" | "42.990" | "20.300" | "47.780" | "55.3" | "24.310" | "82" | "47.63" | "46.85" | "46.11" | "38.12" | "01.61" | "35.240" | "85.32" | "79.121" | "62.900" | "46.340" | "70.1" | "37.00" | "35.1" | "65.300" | "91.42" | "06.10" | "96.230" | "60.31" | "10.82" | "35.123" | "10.12" | "23.150" | "94.910" | "35.150" | "91.11" | "86.221" | "01.13" | "82.990" | "49.12" | "01.250" | "19.10" | "25.630" | "46.220" | "56.30" | "88.101" | "85.699" | "42.91" | "88.996" | "33.12" | "24.2" | "28.25" | "46.35" | "10.11" | "28.990" | "79.901" | "77.340" | "33.160" | "93.291" | "46.2" | "29.10" | "72.20" | "87.10" | "16.12" | "22.12" | "26.11" | "07.1" | "01.44" | "24.33" | "91.212" | "23.120" | "56.2" | "86.103" | "36.00" | "68.320" | "47.740" | "02.400" | "32.2" | "C" | "55.40" | "77.5" | "17.110" | "71.200" | "09.900" | "51.100" | "84.22" | "47.240" | "47" | "86.993" | "66.29" | "10.810" | "96.23" | "23.64" | "46.130" | "30.12" | "Q" | "80.0" | "L" | "82.3" | "02" | "64.220" | "10.89" | "86.23" | "74.910" | "43.990" | "26.200" | "58" | "78.20" | "23.14" | "32.99" | "87.3" | "10.850" | "09.101" | "28.30" | "30.4" | "55.4" | "77.350" | "72" | "86.210" | "93.120" | "47.220" | "60.1" | "91.2" | "33.200" | "61.1" | "03.222" | "55.1" | "02.20" | "68.3" | "58.110" | "47.51" | "49.330" | "10.3" | "46.120" | "56.11" | "01.150" | "01.15" | "23.110" | "15" | "13.95" | "18.140" | "20.110" | "62" | "53.20" | "90.39" | "01.11" | "18.110" | "06" | "49.31" | "68.1" | "22.2" | "46.820" | "25.94" | "62.1" | "17" | "46.640" | "79.110" | "84.30" | "13.9" | "86.960" | "90.111" | "85.52" | "07.21" | "47.530" | "56.120" | "16.220" | "95.25" | "47.631" | "25.22" | "47.71" | "56.22" | "93.19" | "94.1" | "10.41" | "47.7" | "84.120" | "24.41" | "01.210" | "38.320" | "25.11" | "16.210" | "64.3" | "16.260" | "29.20" | "49.200" | "03.221" | "82.4" | "85.310" | "64.9" | "43.60" | "18.13" | "78.100" | "42.110" | "01.479" | "24.540" | "73.120" | "47.82" | "10.13" | "46.160" | "97.001" | "10.860" | "23.52" | "02.30" | "25.510" | "46.36" | "01.22" | "27.510" | "62.200" | "68.32" | "85.59" | "28.15" | "47.230" | "88" | "85.10" | "10.920" | "03.1" | "46.322" | "65.12" | "25.1" | "63.100" | "58.210" | "19.100" | "47.790" | "51.22" | "82.40" | "46.15" | "13.94" | "96.990" | "68.120" | "46.390" | "38.330" | "90.12" | "46.42" | "35.160" | "16" | "56.40" | "84.220" | "23.65" | "74.11" | "47.73" | "56.3" | "10" | "86.922" | "59.110" | "27.520" | "28.210" | "95.100" | "47.1" | "47.761" | "30.120" | "38.3" | "86.970" | "84.210" | "47.250" | "94.20" | "01.290" | "82.920" | "23.7" | "28.3" | "23.66" | "77.2" | "49.33" | "58.290" | "39.00" | "01.630" | "19.2" | "74.300" | "10.86" | "79.12" | "47.77" | "58.1" | "K" | "95.250" | "55.900" | "14.100" | "18.130" | "26.110" | "10.62" | "20.2" | "38.11" | "24.53" | "13.20" | "91.21" | "47.620" | "65.20" | "03.300" | "33.16" | "52" | "72.10" | "85.320" | "15.12" | "10.911" | "26.5" | "74.91" | "88.9" | "26.30" | "20.11" | "33.150" | "29.32" | "85.61" | "93.292" | "77" | "90.20" | "35.122" | "33.14" | "17.12" | "B" | "70.100" | "46.13" | "77.520" | "29.200" | "60.20" | "97" | "85.5" | "46.9" | "38.230" | "27.11" | "84.230" | "85.202" | "91.41" | "03.3" | "25.3" | "87.991" | "11.02" | "27.20" | "10.912" | "46.500" | "20.6" | "46.860" | "10.890" | "36.0" | "01.29" | "38.2" | "22.23" | "86.95" | "28.300" | "93.1" | "46.480" | "25.210" | "47.5" | "25.63" | "01.43" | "88.992" | "01.24" | "88.995" | "96.99" | "10.110" | "01.4" | "32.990" | "74.13" | "35.11" | "73.300" | "47.910" | "85.510" | "52.230" | "66.2" | "88.910" | "30.92" | "64.312" | "52.211" | "13.950" | "47.54" | "28.220" | "63.910" | "27.90" | "26.40" | "52.312" | "64.31" | "30.400" | "55" | "38.310" | "77.35" | "77.400" | "01.420" | "M" | "85.201" | "65.30" | "F" | "49.2" | "23.990" | "64.323" | "43.2" | "91.112" | "43.12" | "27.900" | "10.610" | "47.69" | "63.91" | "27.3" | "43.13" | "93.29" | "87" | "20.41" | "74.12" | "73.11" | "23.62" | "93.11" | "01.500" | "52.10" | "01.110" | "42.1" | "52.260" | "25.110" | "24.420" | "82.400" | "70.10" | "20.30" | "01.16" | "49.340" | "23.70" | "43.91" | "14.290" | "11.06" | "26.400" | "49.4" | "30.32" | "74.2" | "25.61" | "46.170" | "47.559" | "23.15" | "10.92" | "08" | "42.2" | "01.260" | "08.920" | "42.222" | "68" | "74.120" | "47.92" | "28.970" | "32.20" | "73.2" | "10.202" | "99.000" | "01.28" | "81.30" | "93.130" | "95.4" | "30.310" | "42.130" | "01.50" | "47.21" | "94.200" | "01.610" | "86.92" | "26.12" | "82.9" | "87.1" | "82.99" | "82.200" | "38" | "63.920" | "87.102" | "47.3" | "43.420" | "86.97" | "07.10" | "46.810" | "26.600" | "23.620" | "85.531" | "03" | "85.69" | "46.870" | "01.47" | "12.000" | "18.200" | "70.2" | "74.200" | "80.090" | "25.530" | "94.992" | "96.22" | "25.91" | "85.4" | "23.310" | "31" | "66.120" | "90.1" | "22.260" | "46.47" | "30.99" | "17.21" | "25.52" | "43.210" | "46.48" | "85.20" | "05.1" | "52.100" | "21.1" | "90.11" | "09.9" | "73.30" | "58.11" | "52.24" | "27.110" | "23.9" | "46.310" | "49.20" | "65.200" | "46.840" | "69.10" | "52.31" | "23.660" | "77.51" | "94.2" | "47.26" | "95.24" | "35.14" | "80" | "96.1" | "17.230" | "28.2" | "94.11" | "38.22" | "56.220" | "79.902" | "47.750" | "39" | "88.103" | "13.96" | "52.32" | "11.0" | "23.640" | "10.73" | "01.120" | "87.105" | "82.30" | "49.500" | "27.2" | "24.45" | "92.00" | "23.5" | "94.92" | "82.910" | "88.1" | "10.20" | "98" | "96.220" | "14.1" | "46.190" | "87.101" | "07.290" | "29.3" | "64" | "11.05" | "12" | "84.21" | "65" | "95.1" | "43.31" | "24.3" | "13.930" | "00.0" | "08.910" | "38.210" | "90.2" | "75.000" | "92.0" | "78.1" | "10.390" | "43.11" | "64.321" | "11.01" | "46.17" | "35.400" | "47.53" | "77.33" | "20.17" | "15.20" | "23.1" | "55.10" | "52.1" | "77.220" | "24.330" | "24.460" | "28.21" | "52.3" | "47.75" | "77.34" | "87.202" | "97.0" | "21.200" | "47.632" | "47.83" | "71.129" | "07.210" | "20.16" | "42.910" | "88.994" | "11" | "30.11" | "64.311" | "96.400" | "20.130" | "43.6" | "84.3" | "23.20" | "03.212" | "28.290" | "55.300" | "46.850" | "64.21" | "77.52" | "49.410" | "77.310" | "50.20" | "47.61" | "27.31" | "30.1" | "59.2" | "63.1" | "37" | "10.7" | "13.2" | "16.270" | "30.3" | "86.21" | "14.2" | "46.61" | "13.3" | "56.1" | "43.21" | "82.20" | "49.34" | "16.120" | "60.310" | "99" | "81.230" | "46.150" | "43.35" | "64.2" | "27.51" | "61.200" | "13.92" | "63.9" | "85.3" | "33.13" | "77.11" | "81.300" | "35.220" | "68.31" | "21.20" | "46.31" | "46.900" | "77.31" | "84.13" | "90" | "59.11" | "71.1" | "08.930" | "13.91" | "13.10" | "28.42" | "39.000" | "43.34" | "46.330" | "58.29" | "23.42" | "86.91" | "51.210" | "10.83" | "74.20" | "52.21" | "14.240" | "94.991" | "01.1" | "17.1" | "16.110" | "74.130" | "60.39" | "66.1" | "65.110" | "93.190" | "66.21" | "24.410" | "78.2" | "26.700" | "01.5" | "01.14" | "52.320" | "96.910" | "71.121" | "24.520" | "U" | "25" | "46.16" | "61.20" | "16.240" | "59.1" | "60" | "43.23" | "87.30" | "47.210" | "77.210" | "36" | "47.64" | "46.49" | "46.3" | "85.532" | "01.30" | "24" | "O" | "15.11" | "32" | "85.404" | "88.106" | "90.31" | "11.03" | "26.7" | "24.54" | "28.930" | "23.320" | "49.310" | "43.9" | "91.30" | "08.9" | "20.1" | "23.6" | "52.220" | "24.52" | "43.3" | "22.120" | "T" | "65.2" | "20.51" | "13.93" | "70" | "94.91" | "96.3" | "35.121" | "47.830" | "26.2" | "71.122" | "60.2" | "03.12" | "24.51" | "81.23" | "85.51" | "46.41" | "59.200" | "08.99" | "18.14" | "23.700" | "46.83" | "77.320" | "27.40" | "51.1" | "13.99" | "91.3" | "01.26" | "81.10" | "77.3" | "22.110" | "01.130" | "85.6" | "16.26" | "51.10" | "24.510" | "55.200" | "35.13" | "30.31" | "28.4" | "86.104" | "30.9" | "96.210" | "30.990" | "28.94" | "47.24" | "84.25" | "17.24" | "15.1" | "95.21" | "18.1" | "46.380" | "95.320" | "10.51" | "10.520" | "56.21" | "09.109" | "10.52" | "46.64" | "47.12" | "84.24" | "46.630" | "71.20" | "60.10" | "98.100" | "14.29" | "20.160" | "08.12" | "98.20" | "46.50" | "69.201" | "07.100" | "85.595" | "10.81" | "01.220" | "91.22" | "69.2" | "64.91" | "23.410" | "01.620" | "14.230" | "86.921" | "96" | "01.70" | "20.59" | "33.15" | "01.280" | "86.1" | "43.110" | "47.920" | "27.200" | "17.23" | "85.593" | "49.41" | "03.11" | "43.600" | "08.93" | "19.200" | "25.99" | "46.34" | "70.20" | "33.110" | "65.1" | "96.10" | "20.20" | "25.300" | "95.230" | "22.240" | "10.6" | "42.99" | "26.520" | "41.00" | "46.21" | "25.120" | "52.25" | "91.300" | "82.10" | "01.45" | "71.12" | "95.3" | "32.4" | "43.4" | "12.0" | "05.100" | "85.596" | "91.213" | "06.2" | "27.12" | "77.4" | "95.10" | "33.18" | "94.99" | "30.320" | "58.21" | "98.2" | "63.10" | "42" | "24.1" | "86.222" | "68.310" | "47.520" | "35.4" | "96.4" | "56.12" | "47.8" | "74.14" | "90.202" | "74" | "01.140" | "26.1" | "01.6" | "22.25" | "32.40" | "43.120" | "47.30" | "91.420" | "88.99" | "03.110" | "24.340" | "88.102" | "28.120" | "16.22" | "29.2" | "52.2" | "24.4" | "16.1" | "53.100" | "27.320" | "74.110" | "01.48" | "46.90" | "96.100" | "51.2" | "10.130" | "66.11" | "05.200" | "01.300" | "85.521" | "11.060" | "23.200" | "80.09" | "52.212" | "01.3" | "86.96" | "25.6" | "23.510" | "24.34" | "28.950" | "50.202" | "22.1" | "55.30" | "90.390" | "35.40" | "63.92" | "96.2" | "47.91" | "J" | "13.30" | "03.120" | "28.140" | "23" | "46.81" | "47.553" | "73.200" | "64.990" | "28.910" | "D" | "46.1" | "35.130" | "47.4" | "86.992" | "43.240" | "90.310" | "62.10" | "64.11" | "01.430" | "84.300" | "66.3" | "87.106" | "20.410" | "66.30" | "07.2" | "25.9" | "A" | "16.23" | "29.1" | "53.2" | "52.22" | "19" | "71" | "10.120" | "N" | "25.51" | "87.992" | "77.12" | "01.410" | "75" | "10.85" | "87.300" | "64.190" | "69.1" | "01.230" | "61.100" | "49.42" | "61.900" | "32.110" | "80.01" | "46.7" | "96.21" | "53.30" | "10.4" | "47.710" | "95.400" | "08.990" | "13.940" | "46" | "43.410" | "62.2" | "50" | "25.5" | "46.87" | "08.120" | "47.74" | "24.530" | "35.24" | "47.2" | "64.322" | "32.130" | "64.32" | "14.10" | "26.300" | "25.990" | "79.90" | "56" | "96.9" | "12.00" | "77.390" | "23.13" | "91" | "93.12" | "87.91" | "43.500" | "23.43" | "38.23" | "94.920" | "93.21" | "02.3" | "66.19" | "17.22" | "98.200" | "86.230" | "47.72" | "46.84" | "91.4" | "37.0" | "47.40" | "46.430" | "86.101" | "91.12" | "28.22" | "95" | "33.180" | "66.110" | "46.450" | "10.420" | "69.100" | "94.12" | "85.330" | "G" | "94" | "03.211" | "28.250" | "10.830" | "29.31" | "17.250" | "38.33" | "91.111" | "30.91" | "88.991" | "16.27" | "81.1" | "25.930" | "17.210" | "70.200" | "17.240" | "47.540" | "46.350" | "35.23" | "56.4" | "25.520" | "26.20" | "46.23" | "15.110" | "27.52" | "10.31" | "46.86" | "28.95" | "32.50" | "47.810" | "72.200" | "01.190" | "90.3" | "28.130" | "26.6" | "28.91" | "35.140" | "56.400" | "50.1" | "10.9" | "86.930" | "86.94" | "61.9" | "02.1" | "66.300" | "47.820" | "46.890" | "46.24" | "81.220" | "06.20" | "42.221" | "43.130" | "06.1" | "74.990" | "46.710" | "38.31" | "87.104" | "P" | "23.140" | "32.120" | "29.100" | "64.910" | "46.62" | "66.190" | "82.2" | "52.240" | "02.300" | "10.91" | "17.25" | "08.91" | "50.101" | "56.210" | "43.41" | "62.100" | "22" | "66.220" | "47.79" | "46.32" | "27.120" | "73.12" | "23.130" | "26.52" | "15.120" | "32.500" | "46.72" | "I" | "28.240" | "28.920" | "91.211" | "49.110" | "72.2" | "14.23" | "97.002" | "14.24" | "20.200" | "28.41" | "86.2" | "42.22" | "64.99" | "18.120" | "06.200" | "23.63" | "30.110" | "68.200" | "09" | "10.8" | "77.330" | "85.403" | "59.13" | "01.23" | "49.5" | "55.2" | "31.000" | "46.22" | "46.73" | "42.21" | "10.5" | "61.2" | "02.10" | "35.230" | "18.20" | "10.61" | "20.3" | "99.00" | "86.991" | "03.30" | "50.201" | "55.400" | "81.3" | "59.140" | "49.11" | "46.140" | "85.594" | "69.202" | "20.120" | "47.11" | "28" | "84.110" | "37.000" | "55.100" | "77.110" | "43.910" | "84.2" | "42.11" | "22.26" | "50.10" | "46.210" | "01.27" | "01.41" | "24.320" | "01.21" | "03.21" | "64.920" | "74.3" | "25.40" | "52.23" | "46.44" | "53" | "23.12" | "46.620" | "28.9" | "87.2" | "47.510" | "24.44" | "58.190" | "30.40" | "46.82" | "96.300" | "29.310" | "14.220" | "35.3" | "53.10" | "99.0" | "10.710" | "09.1" | "77.21" | "46.321" | "73.1" | "64.1" | "47.300" | "93.2" | "85.31" | "72.1" | "84.11" | "49.390" | "39.0" | "25.53" | "56.110" | "47.25" | "53.1" | "10.320" | "46.63" | "30.20" | "22.230" | "22.11" | "61.10" | "35.21" | "23.45" | "95.22" | "69.20" | "32.910" | "79.9" | "55.90" | "01.19" | "32.200" | "27.4" | "25.12" | "77.32" | "01.270" | "63" | "51.21" | "90.201" | "68.11" | "24.450" | "07" | "78.200" | "85.592" | "36.000" | "88.105" | "43.220" | "05.2" | "86.93" | "81.2" | "02.40" | "24.32" | "95.310" | "75.00" | "60.100" | "46.4" | "46.420" | "27" | "49.320" | "41.0" | "21.10" | "19.20" | "50.203" | "47.690" | "74.30" | "23.91" | "47.400" | "23.11" | "24.46" | "88.10" | "86.9" | "87.910" | "05.10" | "35.2" | "90.112" | "74.99" | "47.76" | "16.250" | "32.13" | "05.20" | "59.130" | "72.100" | "93.13" | "08.92" | "08.1" | "87.999" | "01.42" | "14" | "77.510" | "V" | "16.25" | "85.610" | "23.2" | "23.430" | "95.32" | "10.203" | "49.120" | "25.93" | "52.250" | "41" | "01.481" | "24.42" | "10.72" | "81.210" | "25.92" | "24.440" | "H" | "11.04" | "43.1" | "95.290" | "82.91" | "55.9" | "93.110" | "58.130" | "74.140" | "71.123" | "46.5" | "47.6" | "10.32" | "60.390" | "64.110" | "23.910" | "86.10" | "58.120" | "46.6" | "92.000" | "53.3" | "46.39" | "77.120" | "23.650" | "85.691" | "28.96" | "26.120" | "43.320" | "22.24" | "16.280" | "50.2" | "01.62" | "35.16" | "42.120" | "85.402" | "46.71" | "10.620" | "01.489" | "26.3" | "22.220" | "85.53" | "10.720" | "35.22" | "20.600" | "30.200" | "25.30" | "28.13" | "23.420" | "49.1" | "46.230" | "64.22" | "52.26" | "90.130" | "31.00" | "13" | "85.40" | "46.33" | "84.1" | "47.22" | "10.42" | "66" | "59.20" | "46.14" | "22.22" | "27.1" | "84.240" | "47.770" | "47.610" | "20.510" | "28.99" | "26.4" | "01.451" | "53.200" | "46.43" | "46.18" | "90.209" | "26.51" | "14.22" | "13.990" | "00.00" | "82.300" | "00" | "30" | "87.20" | "92" | "22.21" | "27.32" | "88.993" | "58.12" | "68.2" | "28.11" | "86.942" | "13.920" | "24.20" | "38.21" | "10.410" | "11.070" | "27.33" | "79.11" | "58.13" | "71.11" | "43.32" | "S" | "16.230" | "35.210" | "52.311" | "17.2" | "82.1" | "30.13" | "32.5" | "23.61" | "16.21" | "74.9" | "59.12" | "71.2" | "98.10" | "91.120" | "46.19" | "49.50" | "02.100" | "28.14" | "62.20" | "02.4" | "46.37" | "23.450" | "46.410" | "01.440" | "25.21" | "81" | "42.12" | "47.260" | "81.21" | "25.920";
export type CreateCompleteCompanyCustomerRequest = {
    project_id?: string;
    external_id?: string;
    national_id: string;
    country: CountryEnum;
    name?: string;
    business_address?: Address;
    responsible_user_email?: string;
    parent_national_id?: string;
    global_id?: string;
    office_address?: Address;
    mailing_address?: Address;
    company_type?: CompanyTypeOptions;
    sector_code?: CompanySectorCodes;
    industry_code_1?: IndustryCodeEnum;
    industry_code_2?: IndustryCodeEnum;
    industry_code_3?: IndustryCodeEnum;
    number_of_employees?: number;
    website?: string;
    founded_date?: string;
    closure_date?: string;
    is_bankrupt?: boolean;
    under_liquidation?: boolean;
    under_forced_liquidation_or_dissolution?: boolean;
    registered_in_vat_registry?: boolean;
    registered_in_foundation_registry?: boolean;
    registered_as_nonprofit?: boolean;
    registered_in_business_registry?: boolean;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    extra?: object;
};
export type RoleType = "UNKNOWN_ROLE" | "CEO" | "CHAIRMAN" | "DEPUTY_CHAIRMAN" | "BOARD_MEMBER" | "DEPUTY_BOARD_MEMBER" | "PROPRIETOR" | "CONTACT_PERSON" | "MANAGING_DIRECTOR" | "MANAGER" | "ACCOUNTANT" | "TRUSTEE" | "NORWEGIAN_REPRESENTATIVE" | "AUDITOR" | "OBSERVER" | "ALTERNATE_BOARD_MEMBER" | "PARTICIPANT_PART_RESPONSIBILITY" | "PARTICIPANT_FULL_RESPONSIBILITY" | "COMPLEMENTARY" | "SIGNATURE" | "SIGNATURE_JOINTLY" | "SIGNATURE_SEPARATELY" | "PROCURA" | "PROCURA_JOINTLY" | "PROCURA_SEPARATELY" | "REPRESENTATIVE";
export type CreatePersonRequest = {
    first_name: string;
    last_name: string;
    birth_date: string;
    birth_year?: number;
    national_id?: string;
    national_id_country?: CountryEnum;
    /** A Norwegian phone number. */
    phone?: string;
    country_of_residence: CountryEnum;
    country_of_citizenship: CountryEnum;
    country_of_origin?: CountryEnum;
    address?: Address;
    email?: string;
    is_pep?: boolean;
    is_sanctioned?: boolean;
};
export type OnboardingCreateRoleRequest = {
    /** The type of role. */
    "type": RoleType;
    /** Person to be created that has the role. */
    person: CreatePersonRequest;
    /** Additional comments about the role. */
    comment?: string;
    custom_is_ubo?: boolean;
    screening: boolean;
};
export type OnboardingCreateOwnerRequest = {
    /** Person to be created that contains the personal details of the owner. */
    person: CreatePersonRequest;
    /** Percentage share of the company that the owner holds. */
    percent_share: number;
    /** Additional comments on the owner. */
    comment?: string;
    custom_is_ubo?: boolean;
    /** Indicates whether or not this owner should be a part of the screening. */
    screening?: boolean;
};
export type CompanyScreeningSettings = {
    "type": DataServiceScreeningType;
};
export type EnrichmentSources = {
    basic_info: boolean;
    roles: boolean;
    beneficial_owners: boolean;
};
export type CompanyEnrichmentSettings = {
    sources: EnrichmentSources;
};
export type CompanyOnboardingSettings = {
    screening: CompanyScreeningSettings;
    enrichment?: CompanyEnrichmentSettings;
};
export type CompanyOnboarding = {
    company: CreateCompleteCompanyCustomerRequest;
    roles?: OnboardingCreateRoleRequest[];
    owners?: OnboardingCreateOwnerRequest[];
    settings: CompanyOnboardingSettings;
    responsible_user_email?: string;
};
export type CompanyType = {
    code: string;
    description_en?: string;
    description_nb?: string;
};
export type SectorCode = {
    code: string;
    description_en?: string;
    description_nb?: string;
};
export type IndustryCode = {
    code: string;
    description: string;
    description_en?: string;
    description_nb?: string;
};
export type IndustryRiskDetail = {
    code: string;
    industry_code_description: string;
    has_risk: boolean;
    risk_description?: string;
};
export type IndustryRiskDefinitions = {
    industry_code_1?: IndustryRiskDetail;
    industry_code_2?: IndustryRiskDetail;
    industry_code_3?: IndustryRiskDetail;
};
export type IndustryRiskInformation = {
    industry_types: IndustryRiskDefinitions;
};
export type CompleteCompany = {
    name?: string;
    national_id: string;
    country: CountryEnum;
    address?: Address;
    unhandled_ownership_updates?: number;
    parent_national_id?: string;
    global_id?: string;
    company_type?: CompanyType;
    sector_code?: SectorCode;
    industry_code_1?: IndustryCode;
    industry_code_2?: IndustryCode;
    industry_code_3?: IndustryCode;
    risk_information?: IndustryRiskInformation;
    number_of_employees?: number;
    office_address?: Address;
    business_address?: Address;
    mailing_address?: Address;
    website?: string;
    founded_date?: string;
    closure_date?: string;
    is_bankrupt?: boolean;
    under_liquidation?: boolean;
    under_forced_liquidation_or_dissolution?: boolean;
    registered_in_vat_registry?: boolean;
    registered_in_foundation_registry?: boolean;
    registered_as_nonprofit?: boolean;
    registered_in_business_registry?: boolean;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    can_have_shareholders?: boolean;
    has_ownership_tree?: boolean;
    id: string;
    external_id?: string;
    extra?: object;
};
export type CompleteCompanyOnboardingResponse = {
    company: CompleteCompany;
    settings: CompanyOnboardingSettings;
};
export type DataServiceLegalEntityType = {
    code: string;
    description_en?: string;
    description_nb?: string;
};
export type DataServiceIndustryCode = {
    code: string;
    description_en?: string;
    description_nb?: string;
};
export type DataServiceLegalEntityInfoUpdateFieldChange = {
    field_name: string;
    old?: any;
    "new"?: any;
};
export type DataServiceLegalEntityInfoUpdate = {
    id: number;
    field_changes: DataServiceLegalEntityInfoUpdateFieldChange[];
    timestamp: string;
    is_reviewed: boolean;
};
export type DataServiceLegalEntityDetailResponse = {
    name?: string;
    national_id: string;
    country: string;
    office_address?: Address;
    business_address?: Address;
    id: string;
    global_id?: string;
    parent_national_id?: string;
    legal_entity_type?: DataServiceLegalEntityType;
    sector_code?: SectorCode;
    industry_code_1?: DataServiceIndustryCode;
    industry_code_2?: DataServiceIndustryCode;
    industry_code_3?: DataServiceIndustryCode;
    risk_information?: IndustryRiskInformation;
    mailing_address?: Address;
    website?: string;
    number_of_employees?: number;
    founded_date?: string;
    closure_date?: string;
    is_bankrupt?: boolean;
    under_liquidation?: boolean;
    under_forced_liquidation_or_dissolution?: boolean;
    registered_in_vat_registry?: boolean;
    registered_in_foundation_registry?: boolean;
    registered_as_nonprofit?: boolean;
    registered_in_business_registry?: boolean;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    info_updates: DataServiceLegalEntityInfoUpdate[];
    can_have_shareholders?: boolean;
    unhandled_ownership_updates?: number;
    has_ownership_tree?: boolean;
};
export type DataServiceSubjectEnrichmentStatus = {
    latest_beneficial_ownership_summary?: string;
    latest_role_summary?: string;
};
export type DataServiceLegalEntitySubjectDetailResponse = {
    id: string;
    external_id?: string;
    created_dt?: string;
    screening_status: DataServiceSubjectScreeningStatus;
    risk_level: DataServiceRiskLevel;
    onboarding_status: DataServiceOnboardingStatus;
    review_status: DataServiceReviewStatus;
    pending_measures_count?: number;
    extra?: object;
    responsible?: DataServiceUser;
    responsible_users?: DataServiceUser[];
    is_archived?: boolean;
    archived_by?: DataServiceUser;
    archiving_dt?: string;
    is_manual: boolean;
    projects: DataServiceProjectListItem[];
    labels?: DataServiceLabelListItem[];
    assignments?: DataServiceAssignment[];
    follow_up_date?: string;
    is_follow_up_expired?: boolean;
    has_pending_reviews?: boolean;
    pending_review_id?: string;
    requires_review_approval_by_user?: boolean;
    pending_review_approval_users?: DataServiceUser[];
    pending_review_approval_request_datetime?: string;
    pending_disclosure_count?: number;
    pending_attachment_signature_count?: number;
    draft_review_ids?: string[];
    legal_entity: DataServiceLegalEntityDetailResponse;
    enrichment_status: DataServiceSubjectEnrichmentStatus;
};
export type CustomerType = "person" | "company";
export type GetCustomerByNationalIdRequest = {
    "type": CustomerType;
    national_id: string;
};
export type CustomerUpdateType = "OWNERSHIP_CHANGES" | "ROLE_CHANGES" | "COMPANY_INFO_CHANGES" | "SCREENING_CHANGES";
export type CustomerUpdateEvent = {
    timestamp: string;
    change_type: CustomerUpdateType;
};
export type CustomerUpdateEvents = {
    events?: CustomerUpdateEvent[];
};
export type OrganizationCustomerUpdateEvent = {
    timestamp: string;
    change_type: CustomerUpdateType;
    customer_id: string;
};
export type OrganizationCustomerUpdateEvents = {
    events: OrganizationCustomerUpdateEvent[];
};
export type LanguageEnum = "nb" | "en";
export type SubjectType = "person" | "company";
export type SignaturePreviewRequest = {
    email?: string;
    send_email?: boolean;
    use_standard_disclosure?: boolean;
    use_pep_disclosure?: boolean;
    use_verification?: boolean;
    questionnaire_ids?: string[];
    language?: LanguageEnum;
    assignment_id?: string;
    subject_id?: string;
    subject_type?: SubjectType;
    subject_name?: string;
    organization_id?: string;
};
export type ValidCountriesEnum = "NO";
export type CompanyInformationLookupIndustryCode = {
    code: string;
    description_en: string;
    description_nb: string;
    short_description_en: string;
    short_description_nb: string;
    level1_code?: string;
    level1_code_description_en?: string;
    level1_code_description_nb?: string;
    level1_code_short_description_en?: string;
    level1_code_short_description_nb?: string;
    level2_code?: string;
    level2_code_description_en?: string;
    level2_code_description_nb?: string;
    level2_code_short_description_en?: string;
    level2_code_short_description_nb?: string;
    level3_code?: string;
    level3_code_description_en?: string;
    level3_code_description_nb?: string;
    level3_code_short_description_en?: string;
    level3_code_short_description_nb?: string;
    level4_code?: string;
    level4_code_description_en?: string;
    level4_code_description_nb?: string;
    level4_code_short_description_en?: string;
    level4_code_short_description_nb?: string;
};
export type CompanyInformationLookupInfo = {
    national_id: number;
    parent_national_id?: number;
    name: string;
    legal_entity_type: DataServiceLegalEntityType;
    business_address?: Address;
    mailing_address?: Address;
    office_address?: Address;
    website?: string;
    number_of_employees?: number;
    language?: string;
    registration_date?: string;
    founded_date?: string;
    commencement_date?: string;
    closure_date?: string;
    ownership_date?: string;
    sector_code?: SectorCode;
    industry_code_1?: CompanyInformationLookupIndustryCode;
    industry_code_2?: CompanyInformationLookupIndustryCode;
    industry_code_3?: CompanyInformationLookupIndustryCode;
    risk_information: IndustryRiskInformation;
    last_submitted_annual_accounts?: number;
    registered_as_nonprofit: boolean;
    registered_in_vat_registry: boolean;
    registered_in_business_registry: boolean;
    registered_in_foundation_registry: boolean;
    is_bankrupt?: boolean;
    under_liquidation: boolean;
    under_forced_liquidation_or_dissolution: boolean;
    record_hash?: string;
    record_date: string;
    most_recent_record: boolean;
};
export type CompanyInformationLookupResponse = {
    organisation_number: number;
    response_timestamp: string;
    server_error: boolean;
    bad_request: boolean;
    basic_legal_entity_info: CompanyInformationLookupInfo;
    hash_matched: boolean;
};
export type DirectOwnership = {
    number_of_shares: number;
    share_class: string;
};
export type LookupOwner = {
    name: string;
    birth_year?: number;
    postal_code?: string;
    city?: string;
    country?: string;
    percent_share: string;
    equivalent_shares: string;
    direct_ownership: DirectOwnership[];
};
export type UnknownOwner = {
    postal_code?: string;
    city?: string;
    percent_share: string;
    equivalent_shares: string;
    direct_ownership: DirectOwnership[];
};
export type Stock = {
    organisation_number: number;
    company_name: string;
    isin?: string;
    total_shares: number;
    individual_owners: LookupOwner[];
    unknown_owners: UnknownOwner[];
};
export type CompanyInformationOwnershipLookupResponse = {
    organisation_number: number;
    response_timestamp: string;
    server_error: boolean;
    bad_request: boolean;
    record_year: number;
    cutoff: number;
    top: number;
    stocks: Stock[];
};
export type LookupRole = {
    is_person: boolean;
    is_ubo: boolean;
    name: string;
    birth_year?: number;
    address?: Address;
    role_type: string;
    special_role_type: string;
    role_status: string;
    announcement_date?: string;
    birth_date?: string;
};
export type CompanyInformationRolesLookupResponse = {
    organisation_number: number;
    response_timestamp: string;
    server_error: boolean;
    bad_request: boolean;
    roles: LookupRole[];
};
export type DefinedCountryRiskSourceEnum = "EU" | "EU_TAX_HAVEN" | "FATF";
export type DefinedFatfCountryDetails = {
    last_updated: string;
    blacklisted: boolean;
};
export type DefinedCountryDetails = {
    last_updated: string;
};
export type DefinedCountry = {
    [key: string]: DefinedFatfCountryDetails | DefinedCountryDetails;
};
export type CountryLookupResponse = {
    countries: {
        [key: string]: DefinedCountry;
    };
};
export type DefinedRiskIndustry = {
    industry_code: string;
    industry_category: TranslationText;
    industry_description?: TranslationText;
    value: string;
};
export type IndustryRiskLookupResponse = {
    industries: DefinedRiskIndustry[];
};
export type CreateCompanyCustomerRequest = {
    project_id?: string;
    external_id?: string;
    national_id: string;
    country: CountryEnum;
    name?: string;
    business_address?: Address;
    responsible_user_email?: string;
};
export type OnboardingStatus = "FETCHING_DATA" | "SCREENING_CONFIG" | "SIGNATURE_CONFIG" | "READY" | "DONE";
export type ReviewStatus = "NOT_READY" | "REVIEW_REQUIRED" | "APPROVED" | "REJECTED";
export type CustomerStatus = "STARTED" | "NOT_READY" | "REVIEW_REQUIRED" | "REVIEW_APPROVAL_REQUIRED" | "DRAFT_REVIEW" | "APPROVED" | "REJECTED" | "ARCHIVED";
export type FinishOnboardingTask = {
    "type"?: "FINISH_ONBOARDING";
    onboarding_status: OnboardingStatus;
};
export type ReviewMatchesTask = {
    "type"?: "REVIEW_MATCHES";
    count: number;
    match_case_ids?: string[];
};
export type ReviewCustomerTask = {
    "type"?: "REVIEW_CUSTOMER";
};
export type User = {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    is_active: boolean;
    groups?: number[];
};
export type ApproveCustomerReviewTask = {
    "type"?: "APPROVE_CUSTOMER_REVIEW";
    approval_request_date?: string;
    is_possible_to_approve?: boolean;
    approval_users?: User[];
    review_id?: string;
};
export type FollowUpCustomerTask = {
    "type"?: "FOLLOW_UP_CUSTOMER";
    has_expired: boolean;
    follow_up_date: string;
};
export type CompletePendingMeasuresTask = {
    "type"?: "COMPLETE_PENDING_MEASURES";
    count: number;
};
export type CheckCustomerDisclosuresTask = {
    "type"?: "CHECK_CUSTOMER_DISCLOSURES";
    count: number;
};
export type CheckCustomerAttachmentsTask = {
    "type"?: "CHECK_CUSTOMER_ATTACHMENTS";
    count: number;
};
export type ReviewInfoUpdatesTask = {
    "type"?: "REVIEW_INFO_UPDATES";
};
export type ReviewRoleUpdatesTask = {
    "type"?: "REVIEW_ROLE_UPDATES";
};
export type ReviewOwnershipUpdatesTask = {
    "type"?: "REVIEW_OWNERSHIP_UPDATES";
};
export type ContinueDraftReviewsTask = {
    "type"?: "CONTINUE_DRAFT_REVIEWS";
    review_ids: string[];
};
export type RiskLevel = "NOT_SET" | "LOW" | "MEDIUM" | "HIGH";
export type Label = {
    id: string;
    title: TranslationText;
    read_only?: boolean;
    is_assigned?: boolean;
    color?: string;
};
export type ScreeningType = "NOT_SET" | "NONE" | "ONE_TIME" | "MONITORING";
export type ScreeningStatus = "NOT_STARTED" | "STARTING" | "MONITORING" | "DONE" | "NONE";
export type CustomerScreeningStatus = {
    screening_type?: ScreeningType;
    screening_status: ScreeningStatus;
    screening_started?: string;
    screening_updated?: string;
    screening_stopped?: string;
    unresolved_cases?: number;
    unresolved_cases_ids?: string[];
};
export type CaseStatus = "OPEN" | "PENDING" | "RESOLVED" | "ON_HOLD";
export type CaseSeverity = "LOW" | "MEDIUM" | "HIGH";
export type MatchReview = {
    id: string;
    created_dt: string;
    is_match: boolean;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    negative_news?: boolean;
    other?: boolean;
    description: string;
    reviewed_by?: User;
};
export type MatchCaseSummary = {
    id: string;
    status: CaseStatus;
    severity: CaseSeverity;
    timestamp: string;
    updated_timestamp?: string;
    subject_name: string;
    subject_type: SubjectType;
    match_entity_name: string;
    summary_text: string;
    review?: MatchReview;
};
export type CustomerReviewApproval = {
    approved_by: User;
    is_approved: boolean;
    timestamp: string;
};
export type Measure = {
    id: string;
    measure_config_id?: string;
    title: string;
    description: string;
    created_dt?: string;
    created_by?: User;
    updated_dt?: string;
    updated_by?: User;
    is_completed: boolean;
    completed_by?: User;
    completed_dt?: string;
    completed_comment?: string;
};
export type ReviewChecklistCustomerType = "person" | "company" | "both";
export type ReviewChecklistQuestion = {
    id?: string;
    text: TranslationText;
};
export type RiskCategory = "PEP" | "GEOGRAPHIC_RISK" | "INDUSTRY_RISK" | "SANCTION";
export type ReviewChecklistDisplaySettings = {
    risk_categories: RiskCategory[];
    labels: Label[];
    assignment_purposes: string[];
    assignment_industry_type?: string;
    is_always_select: boolean;
    risk_levels: RiskLevel[];
};
export type ReviewChecklist = {
    id: string;
    name: string;
    description?: string;
    version: number;
    customer_type: ReviewChecklistCustomerType;
    title?: TranslationText;
    created_dt: string;
    created_by?: User;
    updated_dt?: string;
    updated_by?: User;
    is_archived: boolean;
    is_required: boolean;
    questions: ReviewChecklistQuestion[];
    display_settings: ReviewChecklistDisplaySettings;
};
export type ChecklistQuestionAnswer = {
    id: string;
    question_id: string;
    question_text: TranslationText;
    answer: boolean;
    additional_info?: string;
};
export type ChecklistAnswers = {
    id: string;
    checklist: ReviewChecklist;
    answered_by: User;
    answered_dt: string;
    answers: ChecklistQuestionAnswer[];
};
export type CustomerReviewAssignment = {
    id: string;
    industry_type?: string;
    name: string;
    description: string;
    purpose?: string;
    purpose_desc?: string;
};
export type CustomerReviewStatus = "DRAFT" | "PENDING" | "COMPLETE" | "ARCHIVED";
export type CustomerReview = {
    id: string;
    date: string;
    previous_risk_level?: RiskLevel;
    risk_level?: RiskLevel;
    accepted: boolean;
    comment?: string;
    reviewed_by?: User;
    requires_approval: boolean;
    approval?: CustomerReviewApproval;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    approval_users?: User[];
    is_possible_to_approve?: boolean;
    measures: Measure[];
    labels?: Label[];
    checklist_answers?: ChecklistAnswers[];
    assignment?: CustomerReviewAssignment;
    status: CustomerReviewStatus;
};
export type DraftCustomerReview = {
    id: string;
    date: string;
    previous_risk_level?: RiskLevel;
    risk_level?: RiskLevel;
    accepted?: boolean;
    comment?: string;
    reviewed_by?: User;
    requires_approval?: boolean;
    approval?: CustomerReviewApproval;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    approval_users?: User[];
    is_possible_to_approve?: boolean;
    measures?: Measure[];
    labels?: Label[];
    checklist_answers?: ChecklistAnswers[];
    assignment?: CustomerReviewAssignment;
    status: CustomerReviewStatus;
};
export type SigningUserInfo = {
    name: string;
    birth_date?: string;
    country: string;
    social_no?: string;
    address?: Address;
    phone?: string;
    email?: string;
};
export type SigningMethod = "NO_BANKID" | "SE_BANKID" | "SIGNICAT_NO_BANKID";
export type RoleStatus = "ACTIVE" | "EXPIRED";
export type SignerRole = {
    id: string;
    "type": RoleType;
    status: RoleStatus;
    comment?: string;
};
export type Person = {
    id: string;
    first_name: string;
    last_name: string;
    birth_date?: string;
    birth_year?: number;
    national_id?: string;
    national_id_country?: CountryEnum;
    country_of_residence?: CountryEnum;
    country_of_citizenship?: CountryEnum;
    country_of_origin?: CountryEnum;
    address?: Address;
    email?: string;
};
export type AttachmentSignatureStatus = "PENDING" | "SIGNED" | "EXPIRED" | "INVALID_FOR_SIGNING";
export type ValueAndLabel = {
    value: string;
    label: string;
};
export type MifidDisclosure = {
    transaction_role?: ValueAndLabel;
    transaction_role_desc?: string;
    profession?: string;
    industry?: string;
    education_level?: ValueAndLabel;
    financial_instrument_trading_experience?: ValueAndLabel;
    is_accounting_balance_over_threshold?: boolean;
    is_net_turnover_over_threshold?: boolean;
    is_equity_over_threshold?: boolean;
    additional_mifid_info?: string;
};
export type CustomerDisclosure = {
    purposes: ValueAndLabel[];
    purpose_desc?: string;
    sources_of_funds: ValueAndLabel[];
    source_of_funds_desc?: string;
    purpose_reason?: ValueAndLabel;
    purpose_reason_desc?: string;
    usage_of_funds?: ValueAndLabel;
    usage_of_funds_desc?: string;
    additional_info?: string;
    country_of_citizenship?: CountryEnum;
    country_of_origin?: CountryEnum;
    is_acting_on_behalf_of_others?: boolean;
    acting_on_behalf_of_others_desc?: string;
    employment_status?: ValueAndLabel[];
    employer?: string;
    position?: string;
    employment_status_desc?: string;
    phone_number?: string;
    is_pep?: boolean;
    pep_desc?: string;
    pep_role?: ValueAndLabel;
    pep_name?: string;
    pep_birth_date?: string;
    pep_relation?: ValueAndLabel;
    pep_relation_desc?: string;
    pep_position?: ValueAndLabel;
    pep_position_desc?: string;
    pep_position_org?: string;
    pep_position_country?: CountryEnum;
    pep_position_termination_date?: string;
    is_pep_person_form?: boolean;
    is_pep_desc_person_form?: string;
    has_pep_relations_person_form?: boolean;
    has_pep_relations_desc_person_form?: string;
    is_pep_legal_entity_form?: boolean;
    is_pep_desc_legal_entity_form?: string;
    has_pep_relations_legal_entity_form?: boolean;
    has_pep_relations_desc_legal_entity_form?: string;
    has_property_been_upgraded?: boolean;
    property_upgrade_desc?: string;
    is_foreign_assignment?: boolean;
    foreign_assignment_desc?: string;
    foreign_assignment_countries?: CountryEnum[];
    ubo_agreements_exists?: boolean;
    ubo_agreements_desc?: string;
    ubo_family_members_exists?: boolean;
    ubo_family_members_desc?: string;
    is_ubo_structure_changed?: boolean;
    ubo_structure_change_desc?: string;
    has_multiple_share_classes?: boolean;
    share_classes_desc?: string;
    is_part_of_company_structure?: boolean;
    company_structure_desc?: string;
    is_fully_publicly_owned?: boolean;
    is_publicly_owned_or_administrative_body?: boolean;
    company_kind_desc?: string;
    is_listed_on_regulated_market?: boolean;
    regulated_market_name?: string;
    additional_ownership_info?: string;
    mifid?: MifidDisclosure;
    disclosed_by: string;
    timestamp: string;
};
export type QuestionType = "YES_NO" | "TEXT" | "SINGLE_CHOICE" | "MULTIPLE_CHOICE" | "SINGLE_COUNTRY_CHOICE" | "MULTIPLE_COUNTRY_CHOICE";
export type DisclosureQuestion = {
    "type": QuestionType;
    text: TranslationText;
};
export type DisclosureDocumentType = "SHAREHOLDER_BOOK" | "ARTICLES_OF_ASSOCIATION" | "COMPANY_STRUCTURE" | "UBO_AGREEMENT" | "FAMILY_OWNERSHIP" | "POWER_OF_ATTORNEY" | "PRIVATE_LOAN_AGREEMENT" | "PRIVATE_LOAN_AGREEMENT_DEVELOPED_PROPERTY" | "UPGRADE_WORK_DOCUMENTATION" | "UPGRADE_FUNDING_DOCUMENTATION" | "PROPERTY_OWNERSHIP_STRUCTURE" | "HOMEOWNER_POWER_OF_ATTORNEY" | "HOMEOWNER_AGREEMENT";
export type File = {
    id: string;
    file_name: string;
};
export type UploadedDocument = {
    "type": DisclosureDocumentType;
    files: File[];
};
export type DisclosureRiskIndicatorType = "PEP" | "PEP_RCA" | "HIGH_RISK_COUNTRY" | "HIGH_RISK_INDUSTRY" | "MISSING_UPGRADE_WORK_DOCUMENTATION" | "MISSING_UPGRADE_FUNDING_DOCUMENTATION";
export type DisclosureRiskIndicator = {
    "type": DisclosureRiskIndicatorType;
    description: TranslationText;
    additional_description?: TranslationText[];
    country_codes?: CountryEnum[];
};
export type DisclosureAnswer = {
    question: DisclosureQuestion;
    raw_answer?: boolean | number | string | CountryEnum | CountryEnum[] | string | string[];
    answer: TranslationText[] | TranslationText;
    additional_info?: string;
    uploaded_documents?: UploadedDocument[];
    risk_indicators?: DisclosureRiskIndicator[];
};
export type DisclosureAnswerSection = {
    title?: TranslationText;
    answers: DisclosureAnswer[];
};
export type DisclosureAnswers = {
    sections: DisclosureAnswerSection[];
};
export type QuestionChoice = {
    id: string;
    text: TranslationText;
};
export type QuestionInfobox = {
    id: string;
    title: TranslationText;
    text: TranslationText;
};
export type YesNoQuestion = {
    id: string;
    "type": "YES_NO";
    text: TranslationText;
    is_required: boolean;
    choices?: QuestionChoice[];
    infobox?: QuestionInfobox;
    show_infobox: boolean;
};
export type YesNoQuestionAnswer = {
    question: YesNoQuestion;
    answer?: boolean;
};
export type TextQuestion = {
    id: string;
    "type": "TEXT";
    text: TranslationText;
    is_required: boolean;
    choices?: QuestionChoice[];
    infobox?: QuestionInfobox;
    show_infobox: boolean;
};
export type TextQuestionAnswer = {
    question: TextQuestion;
    answer?: string;
};
export type SingleChoiceQuestion = {
    id: string;
    "type": "SINGLE_CHOICE";
    text: TranslationText;
    is_required: boolean;
    choices: QuestionChoice[];
    infobox?: QuestionInfobox;
    show_infobox: boolean;
};
export type SingleChoiceQuestionAnswer = {
    question: SingleChoiceQuestion;
    answer?: QuestionChoice;
};
export type MultipleChoiceQuestion = {
    id: string;
    "type": "MULTIPLE_CHOICE";
    text: TranslationText;
    is_required: boolean;
    choices: QuestionChoice[];
    infobox?: QuestionInfobox;
    show_infobox: boolean;
};
export type MultipleChoiceQuestionAnswer = {
    question: MultipleChoiceQuestion;
    answer?: QuestionChoice[];
};
export type SingleCountryChoiceQuestion = {
    id: string;
    "type": "SINGLE_COUNTRY_CHOICE";
    text: TranslationText;
    is_required: boolean;
    choices?: QuestionChoice[];
    infobox?: QuestionInfobox;
    show_infobox: boolean;
};
export type MultipleCountryChoiceQuestion = {
    id: string;
    "type": "MULTIPLE_COUNTRY_CHOICE";
    text: TranslationText;
    is_required: boolean;
    choices?: QuestionChoice[];
    infobox?: QuestionInfobox;
    show_infobox: boolean;
};
export type CountryChoiceQuestionAnswer = {
    question: SingleCountryChoiceQuestion | MultipleCountryChoiceQuestion;
    answer?: CountryEnum[];
};
export type QuestionnaireAnswer = {
    id: string;
    questionnaire_id: string;
    answered_dt: string;
    answers: (YesNoQuestionAnswer | TextQuestionAnswer | SingleChoiceQuestionAnswer | MultipleChoiceQuestionAnswer | CountryChoiceQuestionAnswer)[];
};
export type SignatureFileSetDocumentType = "SHAREHOLDER_BOOK" | "ARTICLES_OF_ASSOCIATION" | "COMPANY_STRUCTURE" | "UBO_AGREEMENT" | "FAMILY_OWNERSHIP" | "POWER_OF_ATTORNEY" | "PRIVATE_LOAN_AGREEMENT" | "PRIVATE_LOAN_AGREEMENT_DEVELOPED_PROPERTY" | "UPGRADE_WORK_DOCUMENTATION" | "UPGRADE_FUNDING_DOCUMENTATION" | "HOMEOWNER_POWER_OF_ATTORNEY" | "HOMEOWNER_AGREEMENT" | "PROPERTY_OWNERSHIP_STRUCTURE";
export type CustomerFile = {
    id: string;
    filename: string;
};
export type SignatureFileSet = {
    document_type: SignatureFileSetDocumentType;
    disclosure_field: string;
    files: CustomerFile[];
};
export type Signature = {
    signed_dt?: string;
    signing_user_info?: SigningUserInfo;
    signing_method?: SigningMethod;
    notified_dt?: string;
    signing_page_url: string;
    id: string;
    assignment_id?: string;
    assignment_name?: string;
    assignment_purpose?: string;
    role_id?: string;
    role?: SignerRole;
    person: Person;
    send_email?: boolean;
    email?: string;
    language?: LanguageEnum;
    previous_notification_date?: string;
    next_notification_date?: string;
    notifications_sent?: number;
    use_verification: boolean;
    use_standard_disclosure: boolean;
    use_pep_disclosure?: boolean;
    questionnaire_ids?: string[];
    pin_code?: string;
    is_complete: boolean;
    status?: AttachmentSignatureStatus;
    disclosure?: CustomerDisclosure;
    disclosure_answers?: DisclosureAnswers;
    questionnaire_answers?: QuestionnaireAnswer[];
    filesets: SignatureFileSet[];
};
export type CustomerDisclosureDocument = {
    created_dt: string;
    document_type: string;
    is_signed?: boolean;
    signed_dt?: string;
    signature_required?: boolean;
    signatures: Signature[];
};
export type ProjectStatus = "ACTIVE" | "INACTIVE";
export type VitecRole = "SELLER" | "BUYER" | "PROXY" | "ACCOUNT_MANAGER_BUYER" | "ACCOUNT_MANAGER_SELLER" | "SELLERS_SPOUSE" | "HEIR";
export type VitecReportStatus = "WAITING" | "COMPLETED" | "FAILED";
export type VitecReport = {
    id: string;
    status: VitecReportStatus;
    uploaded_dt: string;
    created_dt: string;
};
export type VitecCustomer = {
    id: string;
    role: VitecRole;
    report?: VitecReport;
    proxy_id?: string;
};
export type VitecData = {
    id: string;
    vitec_url?: string;
    customers: VitecCustomer[];
};
export type ProjectIntegrationData = {
    vitec_data?: VitecData;
};
export type ProjectListItem = {
    id: string;
    name: string;
    status: ProjectStatus;
    responsible?: User;
    responsible_users: User[];
    created_dt: string;
    customer_count: number;
    customer_labels?: Label[];
    integrations?: ProjectIntegrationData;
};
export type Assignment = {
    id: string;
    industry_type?: string;
    name: string;
    description: string;
    purpose?: string;
    purpose_desc?: string;
    created_dt: string;
    created_by?: User;
    updated_dt?: string;
    updated_by?: User;
    responsible_users: User[];
    is_accepted?: boolean;
    risk_level?: RiskLevel;
    signature_count: number;
    completed_signature_count: number;
    is_archived: boolean;
    archived_by?: User;
    archived_dt?: string;
    start_date?: string;
    end_date?: string;
};
export type VitecOrder = {
    id: string;
    vitec_estate_url?: string;
    project: string;
};
export type CustomerVitecData = {
    orders?: VitecOrder[];
};
export type KarLookupResult = {
    id: string;
    result: boolean;
    national_id: string;
    account_number: string;
    timestamp: string;
    created_by: User;
};
export type KarLookupResultList = {
    results: KarLookupResult[];
};
export type CustomerIntegrationData = {
    vitec_data?: CustomerVitecData;
    kar_data?: KarLookupResultList;
};
export type OwnerPerson = {
    id: string;
    first_name: string;
    last_name: string;
    birth_date?: string;
    birth_year?: number;
    national_id?: string;
    national_id_country?: CountryEnum;
    country_of_residence?: CountryEnum;
    country_of_citizenship?: CountryEnum;
    country_of_origin?: CountryEnum;
    address?: Address;
    email?: string;
    /** A Norwegian phone number. */
    phone?: string;
    is_pep?: boolean;
    is_sanctioned?: boolean;
};
export type OwnerCompany = {
    name: string;
    national_id?: string;
    address?: Address;
};
export type ShareControl = "NO_CONTROL" | "AML_ACT_UBO" | "MINORITY_CONTROL" | "MAJORITY_CONTROL" | "FULL_CORPORATE_CONTROL";
export type Owner = {
    id?: string;
    person?: OwnerPerson;
    company?: OwnerCompany;
    is_ubo: boolean;
    custom_is_ubo?: boolean;
    percent_share?: string;
    share_control?: ShareControl;
    created_by?: User;
    created_dt?: string;
    updated_by?: User;
    updated_dt?: string;
    deleted?: boolean;
    comment?: string;
    synced_with_vitec?: boolean;
    is_unknown?: boolean;
    unknown_owner_name?: string;
    unknown_owner_address?: Address;
};
export type ShareClass = "UNKNOWN_SHARE_CLASS" | "ORDINARY_SHARES" | "CLASS_A" | "CLASS_B" | "CLASS_C" | "CLASS_D" | "CLASS_E" | "CLASS_F" | "CLASS_G" | "CLASS_H" | "CLASS_I" | "CLASS_J" | "PREFERRED_SHARES" | "EXTRAORDINARY_SHARES" | "ISIN";
export type BeneficialOwnerScreeningConfiguration = {
    owner: Owner;
    screening_required: boolean;
};
export type IdentificationStatus = "PENDING" | "FAILED" | "SUCCESS";
export type RolePerson = {
    id: string;
    first_name: string;
    last_name: string;
    birth_date?: string;
    birth_year?: number;
    national_id?: string;
    national_id_country?: CountryEnum;
    country_of_residence?: CountryEnum;
    country_of_citizenship?: CountryEnum;
    country_of_origin?: CountryEnum;
    address?: Address;
    email?: string;
    identification_required?: boolean;
    identification_status?: IdentificationStatus;
    /** A Norwegian phone number. */
    phone?: string;
    is_pep?: boolean;
    is_sanctioned?: boolean;
};
export type PersonSignatureConfiguration = {
    signature_required?: boolean;
    email?: string;
    send_email?: boolean;
    use_standard_disclosure?: boolean;
    use_pep_disclosure?: boolean;
    use_verification?: boolean;
    questionnaire_ids?: string[];
    language?: LanguageEnum;
    assignment_id?: string;
};
export type Role = {
    id?: string;
    person: RolePerson;
    "type": RoleType;
    status: RoleStatus;
    is_new: boolean;
    is_ubo: boolean;
    custom_is_ubo?: boolean;
    created_by?: User;
    created_dt?: string;
    updated_by?: User;
    updated_dt?: string;
    comment?: string;
    default_signature_configuration?: PersonSignatureConfiguration;
    synced_with_vitec?: boolean;
};
export type RoleScreeningConfiguration = {
    role: Role;
    screening_required: boolean;
};
export type CompanyScreeningConfiguration = {
    beneficial_owners: BeneficialOwnerScreeningConfiguration[];
    beneficial_owners_fetched?: string;
    share_classes?: ShareClass[];
    outstanding_share_count?: number;
    total_share_count?: number;
    ISIN?: string;
    has_outstanding_shares?: boolean;
    customer_id: string;
    customer_name: string;
    roles: RoleScreeningConfiguration[];
    screening_type: ScreeningType;
    screening_status: ScreeningStatus;
    roles_fetched?: string;
    customer_type?: CustomerType;
};
export type CompanyInfoUpdateFieldChange = {
    field_name: string;
    old?: any;
    "new"?: any;
};
export type CompanyInfoUpdate = {
    id: number;
    field_changes: CompanyInfoUpdateFieldChange[];
    timestamp: string;
    is_reviewed: boolean;
};
export type OwnershipUpdateType = "ADDED" | "UPDATED" | "DELETED";
export type OwnershipUpdate = {
    id: string;
    timestamp: string;
    owner_id?: string;
    update_type: OwnershipUpdateType;
    first_name?: string;
    last_name?: string;
    birth_year?: number;
    country_code?: CountryEnum;
    is_ubo: boolean;
    field_changes: CompanyInfoUpdateFieldChange[];
};
export type CompanyUpdates = {
    company_information?: CompanyInfoUpdate[];
    ownership?: OwnershipUpdate[];
};
export type CompanyCustomerDetailResponse = {
    id: string;
    created?: string;
    onboarding_status: OnboardingStatus;
    review_status: ReviewStatus;
    status?: CustomerStatus;
    pending_tasks?: (FinishOnboardingTask | ReviewMatchesTask | ReviewCustomerTask | ApproveCustomerReviewTask | FollowUpCustomerTask | CompletePendingMeasuresTask | CheckCustomerDisclosuresTask | CheckCustomerAttachmentsTask | ReviewInfoUpdatesTask | ReviewRoleUpdatesTask | ReviewOwnershipUpdatesTask | ContinueDraftReviewsTask)[];
    risk_level: RiskLevel;
    external_id?: string;
    extra?: object;
    unresolved_case_count: number;
    unresolved_cases?: string[];
    is_pep: boolean;
    is_sanctioned: boolean;
    responsible?: User;
    responsible_users?: User[];
    is_archived?: boolean;
    archived_by?: User;
    archiving_dt?: string;
    is_manual: boolean;
    labels?: Label[];
    follow_up_date?: string;
    is_follow_up_expired?: boolean;
    screening_status: CustomerScreeningStatus;
    signature_required?: boolean;
    match_cases: MatchCaseSummary[];
    reviews: (CustomerReview | DraftCustomerReview)[];
    pending_reviews: CustomerReview[];
    disclosure_documents: CustomerDisclosureDocument[];
    projects?: ProjectListItem[];
    assignments?: Assignment[];
    name?: string;
    national_id: string;
    country: CountryEnum;
    address?: Address;
    unhandled_ownership_updates?: number;
    parent_national_id?: string;
    global_id?: string;
    company_type?: CompanyType;
    sector_code?: SectorCode;
    industry_code_1?: IndustryCode;
    industry_code_2?: IndustryCode;
    industry_code_3?: IndustryCode;
    risk_information?: IndustryRiskInformation;
    number_of_employees?: number;
    office_address?: Address;
    business_address?: Address;
    mailing_address?: Address;
    website?: string;
    founded_date?: string;
    closure_date?: string;
    is_bankrupt?: boolean;
    under_liquidation?: boolean;
    under_forced_liquidation_or_dissolution?: boolean;
    registered_in_vat_registry?: boolean;
    registered_in_foundation_registry?: boolean;
    registered_as_nonprofit?: boolean;
    registered_in_business_registry?: boolean;
    can_have_shareholders?: boolean;
    has_ownership_tree?: boolean;
    "type"?: CustomerType;
    integrations?: CustomerIntegrationData;
    beneficial_owners: Owner[];
    beneficial_owners_fetched?: string;
    share_classes?: ShareClass[];
    outstanding_share_count?: number;
    total_share_count?: number;
    ISIN?: string;
    has_outstanding_shares?: boolean;
    screening?: CompanyScreeningConfiguration;
    roles_fetched?: string;
    roles: Role[];
    expired_roles: Role[];
    info_updates: CompanyInfoUpdate[];
    updates: CompanyUpdates;
};
export type CreatePersonCustomerRequest = {
    first_name: string;
    last_name: string;
    birth_date: string;
    birth_year?: number;
    national_id?: string;
    national_id_country?: CountryEnum;
    /** A Norwegian phone number. */
    phone?: string;
    country_of_residence: CountryEnum;
    country_of_citizenship: CountryEnum;
    country_of_origin?: CountryEnum;
    address?: Address;
    email?: string;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    project_id?: string;
    external_id?: string;
};
export type PersonScreeningConfiguration = {
    customer_id: string;
    customer_name: string;
    screening_type: ScreeningType;
    screening_status: ScreeningStatus;
    customer_type?: CustomerType;
};
export type PersonCustomerDetailResponse = {
    id: string;
    created?: string;
    onboarding_status: OnboardingStatus;
    review_status: ReviewStatus;
    status?: CustomerStatus;
    pending_tasks?: (FinishOnboardingTask | ReviewMatchesTask | ReviewCustomerTask | ApproveCustomerReviewTask | FollowUpCustomerTask | CompletePendingMeasuresTask | CheckCustomerDisclosuresTask | CheckCustomerAttachmentsTask | ReviewInfoUpdatesTask | ReviewRoleUpdatesTask | ReviewOwnershipUpdatesTask | ContinueDraftReviewsTask)[];
    risk_level: RiskLevel;
    external_id?: string;
    extra?: object;
    unresolved_case_count: number;
    unresolved_cases?: string[];
    is_pep: boolean;
    is_sanctioned: boolean;
    responsible?: User;
    responsible_users?: User[];
    is_archived?: boolean;
    archived_by?: User;
    archiving_dt?: string;
    is_manual: boolean;
    labels?: Label[];
    follow_up_date?: string;
    is_follow_up_expired?: boolean;
    screening_status: CustomerScreeningStatus;
    signature_required?: boolean;
    match_cases: MatchCaseSummary[];
    reviews: (CustomerReview | DraftCustomerReview)[];
    pending_reviews: CustomerReview[];
    disclosure_documents: CustomerDisclosureDocument[];
    projects?: ProjectListItem[];
    assignments?: Assignment[];
    first_name: string;
    last_name: string;
    birth_date?: string;
    birth_year?: number;
    national_id?: string;
    national_id_country?: CountryEnum;
    country_of_residence?: CountryEnum;
    country_of_citizenship?: CountryEnum;
    country_of_origin?: CountryEnum;
    address?: Address;
    email?: string;
    person_id: string;
    /** A Norwegian phone number. */
    phone?: string;
    "type"?: CustomerType;
    integrations?: CustomerIntegrationData;
    screening?: PersonScreeningConfiguration;
};
export type UpdatePersonCustomerRequest = {
    first_name?: string;
    last_name?: string;
    birth_date?: string;
    birth_year?: number;
    national_id?: string;
    national_id_country?: CountryEnum;
    /** A Norwegian phone number. */
    phone?: string;
    country_of_residence?: CountryEnum;
    country_of_citizenship?: CountryEnum;
    country_of_origin?: CountryEnum;
    address?: Address;
    email?: string;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    project_id?: string;
    external_id?: string;
    is_archived?: boolean;
};
export type PersonCustomer = {
    id: string;
    created?: string;
    onboarding_status: OnboardingStatus;
    review_status: ReviewStatus;
    status?: CustomerStatus;
    pending_tasks?: (FinishOnboardingTask | ReviewMatchesTask | ReviewCustomerTask | ApproveCustomerReviewTask | FollowUpCustomerTask | CompletePendingMeasuresTask | CheckCustomerDisclosuresTask | CheckCustomerAttachmentsTask | ReviewInfoUpdatesTask | ReviewRoleUpdatesTask | ReviewOwnershipUpdatesTask | ContinueDraftReviewsTask)[];
    risk_level: RiskLevel;
    external_id?: string;
    extra?: object;
    unresolved_case_count: number;
    unresolved_cases?: string[];
    is_pep: boolean;
    is_sanctioned: boolean;
    responsible?: User;
    responsible_users?: User[];
    is_archived?: boolean;
    archived_by?: User;
    archiving_dt?: string;
    is_manual: boolean;
    labels?: Label[];
    follow_up_date?: string;
    is_follow_up_expired?: boolean;
    first_name: string;
    last_name: string;
    birth_date?: string;
    birth_year?: number;
    national_id?: string;
    national_id_country?: CountryEnum;
    country_of_residence?: CountryEnum;
    country_of_citizenship?: CountryEnum;
    country_of_origin?: CountryEnum;
    address?: Address;
    email?: string;
    person_id: string;
    /** A Norwegian phone number. */
    phone?: string;
    "type"?: CustomerType;
};
export type PutCompanyScreeningConfigurationRequest = {
    roles: string[];
    owners: string[];
    screening_type: ScreeningType;
};
export type PatchCompanyScreeningConfigurationRequest = {
    roles: string[];
    owners: string[];
    screening_type: ScreeningType;
};
export type PersonScreeningConfigurationRequest = {
    screening_type: ScreeningType;
};
export type SignatureRole = {
    id?: string;
    person: RolePerson;
    "type": RoleType;
    status: RoleStatus;
    is_new: boolean;
    is_ubo: boolean;
    custom_is_ubo?: boolean;
    created_by?: User;
    created_dt?: string;
    updated_by?: User;
    updated_dt?: string;
    comment?: string;
    default_signature_configuration?: PersonSignatureConfiguration;
    synced_with_vitec?: boolean;
};
export type SigningCombination = {
    code: string;
    description: string;
    signers: string[];
};
export type CompanySignatureConfiguration = {
    signing_basis_exists: boolean;
    signature_description?: string;
    signatures: Signature[];
    possible_signers: SignatureRole[];
    possible_combinations: SigningCombination[];
    signature_descriptions: string[];
    assignment_id?: string;
};
export type CompanyRoleSignatureConfiguration = {
    email?: string;
    send_email?: boolean;
    use_standard_disclosure?: boolean;
    use_pep_disclosure?: boolean;
    use_verification?: boolean;
    questionnaire_ids?: string[];
    language?: LanguageEnum;
    assignment_id?: string;
    id: string;
};
export type PutCompanySignatureConfigurationRequest = {
    signature_required?: boolean;
    assignment_id?: string;
    signatures?: CompanyRoleSignatureConfiguration[];
};
export type FileDownloadUrl = {
    download_url: string;
};
export type RelatedResultType = "ROLE" | "OWNER";
export type RelatedRole = {
    result_type: RelatedResultType;
    archived: boolean;
    id: string;
    first_name?: string;
    last_name?: string;
    birth_date?: string;
    birth_year?: number;
    "type": RoleType;
};
export type RelatedOwner = {
    result_type: RelatedResultType;
    archived: boolean;
    id: string;
    first_name?: string;
    last_name?: string;
    birth_date?: string;
    birth_year?: number;
    is_ubo: boolean;
    percent_share: number;
};
export type CompanySearchResult = {
    id: string;
    created?: string;
    onboarding_status: OnboardingStatus;
    review_status: ReviewStatus;
    status?: CustomerStatus;
    pending_tasks?: (FinishOnboardingTask | ReviewMatchesTask | ReviewCustomerTask | ApproveCustomerReviewTask | FollowUpCustomerTask | CompletePendingMeasuresTask | CheckCustomerDisclosuresTask | CheckCustomerAttachmentsTask | ReviewInfoUpdatesTask | ReviewRoleUpdatesTask | ReviewOwnershipUpdatesTask | ContinueDraftReviewsTask)[];
    risk_level: RiskLevel;
    external_id?: string;
    is_pep: boolean;
    is_sanctioned: boolean;
    responsible_users?: User[];
    is_archived?: boolean;
    archived_by?: User;
    archiving_dt?: string;
    labels?: Label[];
    name?: string;
    national_id: string;
    unhandled_ownership_updates?: number;
    is_manual: boolean;
    related_search_results?: (RelatedRole | RelatedOwner)[];
    "type"?: CustomerType;
};
export type PersonSearchResult = {
    id: string;
    created?: string;
    onboarding_status: OnboardingStatus;
    review_status: ReviewStatus;
    status?: CustomerStatus;
    pending_tasks?: (FinishOnboardingTask | ReviewMatchesTask | ReviewCustomerTask | ApproveCustomerReviewTask | FollowUpCustomerTask | CompletePendingMeasuresTask | CheckCustomerDisclosuresTask | CheckCustomerAttachmentsTask | ReviewInfoUpdatesTask | ReviewRoleUpdatesTask | ReviewOwnershipUpdatesTask | ContinueDraftReviewsTask)[];
    risk_level: RiskLevel;
    external_id?: string;
    is_pep: boolean;
    is_sanctioned: boolean;
    responsible_users?: User[];
    is_archived?: boolean;
    archived_by?: User;
    archiving_dt?: string;
    labels?: Label[];
    first_name: string;
    last_name: string;
    "type"?: CustomerType;
};
export type SearchResultResponse = {
    count: number;
    has_pending_tasks_count?: number;
    customers: (CompanySearchResult | PersonSearchResult)[];
};
export type CustomerCountsResponse = {
    count: number;
    has_pending_tasks_count?: number;
};
export type UpdateCustomerRequest = {
    responsible_id?: string;
    responsible_users?: string[];
    external_id?: string;
    is_archived?: boolean;
    follow_up_date?: string;
};
export type UpdateAddressRequest = {
    address_line_1?: string;
    address_line_2?: string;
    postal_code?: string;
    city?: string;
    county?: string;
    country: CountryEnum;
};
export type UpdateCompanyCustomerRequest = {
    responsible_id?: string;
    responsible_users?: string[];
    external_id?: string;
    is_archived?: boolean;
    follow_up_date?: string;
    national_id?: string;
    country?: CountryEnum;
    name?: string;
    business_address?: UpdateAddressRequest;
};
export type CompanyCustomer = {
    id: string;
    created?: string;
    onboarding_status: OnboardingStatus;
    review_status: ReviewStatus;
    status?: CustomerStatus;
    pending_tasks?: (FinishOnboardingTask | ReviewMatchesTask | ReviewCustomerTask | ApproveCustomerReviewTask | FollowUpCustomerTask | CompletePendingMeasuresTask | CheckCustomerDisclosuresTask | CheckCustomerAttachmentsTask | ReviewInfoUpdatesTask | ReviewRoleUpdatesTask | ReviewOwnershipUpdatesTask | ContinueDraftReviewsTask)[];
    risk_level: RiskLevel;
    external_id?: string;
    extra?: object;
    unresolved_case_count: number;
    unresolved_cases?: string[];
    is_pep: boolean;
    is_sanctioned: boolean;
    responsible?: User;
    responsible_users?: User[];
    is_archived?: boolean;
    archived_by?: User;
    archiving_dt?: string;
    is_manual: boolean;
    labels?: Label[];
    follow_up_date?: string;
    is_follow_up_expired?: boolean;
    name?: string;
    national_id: string;
    country: CountryEnum;
    address?: Address;
    unhandled_ownership_updates?: number;
    "type"?: CustomerType;
};
export type MatchAttribute = {
    code: string;
    description: string;
    value: string;
    detail?: string;
    is_reviewed: boolean;
    source_key?: string;
};
export type MatchAddress = {
    locator_typ?: string;
    addr1?: string;
    addr2?: string;
    city?: string;
    state_prov?: string;
    country_code?: string;
    from_dt?: string;
    to_dt?: string;
    source_key?: string;
    is_reviewed: boolean;
};
export type MatchRelation = {
    direction: string;
    "type": string;
    sys_id: string;
    entity_name: string;
    is_reviewed: boolean;
};
export type MatchSource = {
    source_name?: string;
    source_url?: string;
    entity_dt?: string;
    headline?: string;
    publication_source?: string;
    publisher?: string;
    is_reviewed: boolean;
};
export type MatchCategory = {
    code: string;
    description: string;
};
export type Source = {
    source_name?: string;
    source_url?: string;
    entity_dt?: string;
    headline?: string;
    publication_source?: string;
    publisher?: string;
};
export type MatchEvent = {
    category: MatchCategory;
    sub_category: MatchCategory;
    description: string;
    date?: string;
    source?: Source;
    source_key?: string;
    is_reviewed: boolean;
};
export type MatchAlias = {
    "type": string;
    name: string;
    is_reviewed: boolean;
};
export type MatchPosition = {
    value: string;
    source_key?: string;
    is_reviewed: boolean;
};
export type MatchBirthDate = {
    value: string;
    source_key?: string;
    is_reviewed: boolean;
};
export type PersonDetail = {
    id: string;
    first_name: string;
    last_name: string;
    birth_date?: string;
    birth_year?: number;
    national_id?: string;
    national_id_country?: CountryEnum;
    country_of_residence?: CountryEnum;
    country_of_citizenship?: CountryEnum;
    country_of_origin?: CountryEnum;
    address?: Address;
    email?: string;
    country_of_domicile?: CountryEnum;
    gender?: GenderEnum;
    phone?: string;
    is_pep?: boolean;
    is_sanctioned?: boolean;
};
export type CompanyDetail = {
    name?: string;
    national_id: string;
    country: CountryEnum;
    address?: Address;
    unhandled_ownership_updates?: number;
    parent_national_id?: string;
    global_id?: string;
    company_type?: CompanyType;
    sector_code?: SectorCode;
    industry_code_1?: IndustryCode;
    industry_code_2?: IndustryCode;
    industry_code_3?: IndustryCode;
    risk_information?: IndustryRiskInformation;
    number_of_employees?: number;
    office_address?: Address;
    business_address?: Address;
    mailing_address?: Address;
    website?: string;
    founded_date?: string;
    closure_date?: string;
    is_bankrupt?: boolean;
    under_liquidation?: boolean;
    under_forced_liquidation_or_dissolution?: boolean;
    registered_in_vat_registry?: boolean;
    registered_in_foundation_registry?: boolean;
    registered_as_nonprofit?: boolean;
    registered_in_business_registry?: boolean;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    can_have_shareholders?: boolean;
    has_ownership_tree?: boolean;
};
export type Match = {
    id: string;
    match_score?: number;
    risk_score?: number;
    entity_name: string;
    attributes: MatchAttribute[];
    addresses: MatchAddress[];
    relations: MatchRelation[];
    source: MatchSource;
    sources: MatchSource[];
    events: MatchEvent[];
    aliases: MatchAlias[];
    positions: MatchPosition[];
    birth_dates: MatchBirthDate[];
    timestamp: string;
    updated_timestamp?: string;
    review_required: boolean;
    subject_type: SubjectType;
    subject: PersonDetail | CompanyDetail;
};
export type MatchListResponse = {
    matches: Match[];
};
export type MatchDetailResponse = {
    customer_id: string;
    customer_name: string;
    customer_type: CustomerType;
    match: Match;
};
export type MatchCaseListResponse = {
    match_cases: MatchCaseSummary[];
};
export type NewMatchSource = {
    source_name?: string;
    source_url?: string;
    entity_dt?: string;
    headline?: string;
    publication_source?: string;
    publisher?: string;
    is_reviewed: boolean;
    attributes?: MatchAttribute[];
    addresses?: MatchAddress[];
    birth_dates?: MatchBirthDate[];
    positions?: MatchPosition[];
    events?: MatchEvent[];
};
export type NewMatch = {
    id: string;
    match_score?: number;
    risk_score?: number;
    entity_name: string;
    aliases: MatchAlias[];
    birth_dates: MatchBirthDate[];
    addresses: MatchAddress[];
    relations: MatchRelation[];
    source: MatchSource;
    sources: {
        [key: string]: NewMatchSource;
    };
    pep_sources: string[];
    sanction_sources: string[];
    adverse_media_sources: string[];
    timestamp: string;
    updated_timestamp?: string;
    review_required: boolean;
    subject_type: SubjectType;
    subject: PersonDetail | CompanyDetail;
};
export type MatchCaseDetail = {
    id: string;
    match: Match;
    match_new: NewMatch;
    timestamp: string;
    updated_timestamp?: string;
    status: CaseStatus;
    severity: CaseSeverity;
    responsible?: User;
    resolved_dt?: string;
    resolved_by?: User;
    reviews: MatchReview[];
    summary_text: string;
};
export type MatchCaseDetailResponse = {
    customer_id: string;
    customer_name: string;
    customer_type: CustomerType;
    customer_is_archived: boolean;
    "case": MatchCaseDetail;
};
export type CreateMatchReviewRequest = {
    is_match: boolean;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    negative_news?: boolean;
    other?: boolean;
    description: string;
};
export type CreateMeasureRequest = {
    id?: string;
    measure_config_id?: string;
    title: string;
    description: string;
    completed_comment?: string;
    is_completed?: boolean;
};
export type ChecklistQuestionAnswerRequest = {
    question_id: string;
    answer: boolean;
    additional_info?: string;
};
export type ChecklistAnswersRequest = {
    checklist_id: string;
    version: number;
    answers: ChecklistQuestionAnswerRequest[];
};
export type CreateCustomerReviewRequest = {
    accepted: boolean;
    is_pep: boolean;
    is_sanctioned: boolean;
    risk_level: RiskLevel;
    comment: string;
    requires_approval?: boolean;
    approval_user_ids?: string[];
    assignment_id?: string;
    measures?: CreateMeasureRequest[];
    labels?: Label[];
    checklist_answers?: ChecklistAnswersRequest[];
};
export type UpdateCustomerReviewRequest = {
    accepted: boolean;
    is_pep: boolean;
    is_sanctioned: boolean;
    risk_level: RiskLevel;
    comment: string;
    requires_approval?: boolean;
    approval_user_ids?: string[];
    assignment_id?: string;
    measures?: CreateMeasureRequest[];
    labels?: Label[];
    checklist_answers?: ChecklistAnswersRequest[];
};
export type CreateDraftCustomerReviewRequest = {
    accepted?: boolean;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    risk_level?: RiskLevel;
    comment?: string;
    requires_approval?: boolean;
    approval_user_ids?: string[];
    assignment_id?: string;
    measures?: CreateMeasureRequest[];
    labels?: Label[];
    checklist_answers?: ChecklistAnswersRequest[];
};
export type UpdateDraftCustomerReviewRequest = {
    accepted?: boolean;
    is_pep?: boolean;
    is_sanctioned?: boolean;
    risk_level?: RiskLevel;
    comment?: string;
    requires_approval?: boolean;
    approval_user_ids?: string[];
    assignment_id?: string;
    measures?: CreateMeasureRequest[];
    labels?: Label[];
    checklist_answers?: ChecklistAnswersRequest[];
};
export type UpdateMeasureRequest = {
    title: string;
    description: string;
    completed_comment?: string;
    is_completed: boolean;
};
export type MeasureMoveDirection = "UP" | "DOWN";
export type MoveMeasureRequest = {
    direction: MeasureMoveDirection;
};
export type CreateRoleRequest = {
    /** The type of role. */
    "type": RoleType;
    /** Person to be created that has the role. */
    person: CreatePersonRequest;
    /** Additional comments about the role. */
    comment?: string;
    custom_is_ubo?: boolean;
};
export type SyncRoleRequest = {
    role_id: string;
};
export type SyncOwnerRequest = {
    owner_id: string;
};
export type UpdatePersonRequest = {
    first_name?: string;
    last_name?: string;
    birth_date?: string;
    birth_year?: number;
    national_id?: string;
    national_id_country?: CountryEnum;
    /** A Norwegian phone number. */
    phone?: string;
    email?: string;
    country_of_residence?: CountryEnum;
    country_of_citizenship?: CountryEnum;
    country_of_origin?: CountryEnum;
    address?: UpdateAddressRequest;
    is_pep?: boolean;
    is_sanctioned?: boolean;
};
export type UpdateRoleRequest = {
    "type"?: RoleType;
    status?: RoleStatus;
    person?: UpdatePersonRequest;
    comment?: string;
    custom_is_ubo?: boolean;
};
export type CreateOwnerRequest = {
    /** Person to be created that contains the personal details of the owner. */
    person: CreatePersonRequest;
    /** Percentage share of the company that the owner holds. */
    percent_share: number;
    /** Additional comments on the owner. */
    comment?: string;
    custom_is_ubo?: boolean;
};
export type UpdateOwnerRequest = {
    person?: UpdatePersonRequest;
    percent_share?: number;
    deleted?: boolean;
    comment?: string;
    custom_is_ubo?: boolean;
};
export type PatchPersonSignatureConfigurationRequest = {
    email?: string;
    send_email?: boolean;
    use_standard_disclosure?: boolean;
    use_pep_disclosure?: boolean;
    use_verification?: boolean;
    questionnaire_ids?: string[];
    language?: LanguageEnum;
    assignment_id?: string;
    signature_required?: boolean;
};
export type UpdateSignatureRequest = {
    email?: string;
    send_email?: boolean;
    use_standard_disclosure?: boolean;
    use_pep_disclosure?: boolean;
    use_verification?: boolean;
    questionnaire_ids?: string[];
    language?: LanguageEnum;
    assignment_id?: string;
};
export type CreateCompanyCustomerDisclosureDocumentRequest = {
    signatures: CompanyRoleSignatureConfiguration[];
    assignment_id?: string;
};
export type CreatePersonCustomerDisclosureDocumentRequest = {
    email?: string;
    send_email?: boolean;
    use_standard_disclosure?: boolean;
    use_pep_disclosure?: boolean;
    use_verification?: boolean;
    questionnaire_ids?: string[];
    language?: LanguageEnum;
    assignment_id?: string;
};
export type AttachmentDownloadUrl = {
    download_url: string;
};
export type SignedAttachmentDocumentStatus = "EXISTS" | "DELETED";
export type AttachmentDetails = {
    id: string;
    created_dt: string;
    created_by?: User;
    filename: string;
    signature_required: boolean;
    signature_count: number;
    completed_signature_count: number;
    signature_status?: AttachmentSignatureStatus;
    signed_document_status?: SignedAttachmentDocumentStatus;
    signed_document_deleted_timestamp?: string;
    signed_document_deleted_by?: User;
    assignment_id?: string;
    assignment_name?: string;
    assignment_purpose?: string;
    assignment_is_archived?: boolean;
};
export type AttachmentDetailsList = {
    attachment_list: AttachmentDetails[];
};
export type CreateAttachmentMetadataRequest = {
    filename: string;
    upload_id: string;
};
export type SavedAttachmentSignature = {
    signed_dt?: string;
    signing_user_info?: SigningUserInfo;
    signing_method?: SigningMethod;
    notified_dt?: string;
    signing_page_url: string;
    id?: string;
    signer_id?: string;
    role_id?: string;
    first_name?: string;
    last_name?: string;
    national_id?: string;
    send_email: boolean;
    email?: string;
    use_verification: boolean;
    pin: string;
    status: AttachmentSignatureStatus;
    role?: SignerRole;
};
export type AttachmentSignaturesResponse = {
    signatures: SavedAttachmentSignature[];
};
export type CreateOrUpdateAttachmentSignatureRequest = {
    id?: string;
    signer_id?: string;
    role_id?: string;
    first_name?: string;
    last_name?: string;
    national_id?: string;
    send_email: boolean;
    email?: string;
    use_verification: boolean;
};
export type UpdateAttachmentSignaturesRequest = {
    signatures: CreateOrUpdateAttachmentSignatureRequest[];
    "delete"?: boolean;
};
export type BatchSetFollowUpDateOnCustomersRequest = {
    customer_ids: string[];
    follow_up_date?: string;
};
export type CustomerListResponse = {
    count: number;
    has_pending_tasks_count?: number;
    customers: (CompanyCustomer | PersonCustomer)[];
};
export type BatchSetResponsibleUsersOnCustomers = {
    customer_ids: string[];
    user_ids: string[];
};
export type BatchCustomersRequestBase = {
    customer_ids: string[];
};
export type LabelsOnTargets = {
    target_ids: string[];
    label_ids: string[];
};
export type TitleOnTargets = {
    target_ids: string[];
    title: TranslationText;
};
export type ConfirmAllOwnershipUpdatesResponse = {
    owners: Owner[];
};
export type CreateOrUpdateAssignmentRequest = {
    name: string;
    description: string;
    responsible_users?: string[];
    start_date?: string;
    end_date?: string;
    industry_type?: string;
    purpose?: string;
    purpose_desc?: string;
};
export type AssignmentReview = {
    id: string;
    created_dt: string;
    reviewed_by?: User;
    is_accepted: boolean;
    risk_level: RiskLevel;
    comment: string;
};
export type CustomerAssignmentDetails = {
    id: string;
    industry_type?: string;
    name: string;
    description: string;
    purpose?: string;
    purpose_desc?: string;
    created_dt: string;
    created_by?: User;
    updated_dt?: string;
    updated_by?: User;
    responsible_users: User[];
    is_accepted?: boolean;
    risk_level?: RiskLevel;
    signature_count: number;
    completed_signature_count: number;
    is_archived: boolean;
    archived_by?: User;
    archived_dt?: string;
    start_date?: string;
    end_date?: string;
    customer_id: string;
    customer_name: string;
    customer_type: CustomerType;
    disclosure_documents: CustomerDisclosureDocument[];
    reviews: AssignmentReview[];
};
export type CreateAssignmentReviewRequest = {
    is_accepted: boolean;
    risk_level: RiskLevel;
    comment: string;
};
export type BranchOwnership = {
    percent_owned: number;
    relative_percent_owned: number;
    share_class: ShareClass;
    shares_owned: number;
    total_shares: number;
};
export type Child = {
    node: OwnershipTreeNode;
    ownership: BranchOwnership[];
};
export type OwnershipTreeNode = {
    owner: Owner;
    children: Child[];
};
export type OwnershipTree = {
    root_node: OwnershipTreeNode;
};
export type OwnershipTreeResponse = {
    ownership_tree?: OwnershipTree;
};
export type NotationVisibility = "COMPLIANCE_OFFICER" | "GLOBAL" | "KDK_ADMIN" | "MLRO" | "USER";
export type CustomerNotation = {
    comment: string;
    visibility?: NotationVisibility;
    id: string;
    user?: User;
    customer_id: string;
    created_dt: string;
    updated_dt: string;
};
export type BaseNotation = {
    comment: string;
    visibility?: NotationVisibility;
};
export type CustomerReviewNotation = {
    comment: string;
    visibility?: NotationVisibility;
    id: string;
    user?: User;
    review_id: string;
    created_dt: string;
    updated_dt: string;
};
export type KarLookupRequest = {
    national_id: string;
    account_number: string;
};
export type ProjectList = {
    count: number;
    projects: ProjectListItem[];
};
export type CreateProjectRequest = {
    name: string;
    description: string;
    customer_ids?: string[];
};
export type ProjectReview = {
    id: string;
    created_dt: string;
    comment: string;
    reviewed_by?: User;
};
export type Project = {
    id: string;
    name: string;
    description: string;
    status: ProjectStatus;
    responsible?: User;
    responsible_users: User[];
    created_dt: string;
    created_by?: User;
    updated_by?: User;
    updated_dt?: string;
    stopped_by?: User;
    stopped_dt?: string;
    customers: (CompanyCustomer | PersonCustomer)[];
    reviews: ProjectReview[];
    integrations?: ProjectIntegrationData;
};
export type UpdateProjectRequest = {
    name?: string;
    description?: string;
    customer_ids?: string[];
    status?: ProjectStatus;
    responsible_id?: string;
    responsible_users?: string[];
};
export type ProjectCustomersDetails = {
    customers: (CompanyCustomerDetailResponse | PersonCustomerDetailResponse)[];
};
export type CreateProjectReviewRequest = {
    comment: string;
};
export type AttachmentUploadRequest = {
    filename: string;
    content_length: number;
    content_type?: string;
};
export type AttachmentUploadResponse = {
    upload_url: string;
    upload_id: string;
};
export type GroupRoleKey = "MLRO" | "COMPLIANCE_OFFICER" | "KDK_ADMIN";
export type Group = {
    id: number;
    name: string;
    role_key?: GroupRoleKey;
};
export type UserListResponse = {
    users: User[];
    groups: Group[];
};
export type CreateUserRequest = {
    first_name: string;
    last_name: string;
    email: string;
    groups?: number[];
};
export type UpdateUserRequest = {
    first_name: string;
    last_name: string;
    email: string;
    is_active: boolean;
    groups?: number[];
};
export type LabelList = {
    count: number;
    labels: Label[];
};
export type LabelData = {
    title: TranslationText;
    color?: string;
};
export type NaceIndustryCode = {
    code: IndustryCodeEnum;
    name: TranslationText;
};
export type NaceIndustryCodesList = {
    industry_codes: NaceIndustryCode[];
};
export type QuestionnaireCustomerType = "person" | "company" | "both";
export type Question = {
    id: string;
    "type": QuestionType;
    text: TranslationText;
    is_required: boolean;
    choices?: QuestionChoice[];
    infobox?: QuestionInfobox;
    show_infobox: boolean;
};
export type Questionnaire = {
    id: string;
    name: string;
    description?: string;
    version: number;
    title?: TranslationText;
    created_dt: string;
    created_by?: User;
    updated_dt?: string;
    updated_by?: User;
    is_archived: boolean;
    customer_type: QuestionnaireCustomerType;
    questions: Question[];
};
export type QuestionnaireListResponse = {
    questionnaires: Questionnaire[];
};
export type CreateQuestionChoiceRequest = {
    text: TranslationText;
};
export type CreateQuestionInfoboxRequest = {
    title: TranslationText;
    text: TranslationText;
};
export type CreateQuestionRequest = {
    "type": QuestionType;
    text: TranslationText;
    is_required: boolean;
    choices?: CreateQuestionChoiceRequest[];
    infobox?: CreateQuestionInfoboxRequest;
    show_infobox: boolean;
};
export type CreateQuestionnaireRequest = {
    name: string;
    description?: string;
    title?: TranslationText;
    customer_type: QuestionnaireCustomerType;
    questions: CreateQuestionRequest[];
};
export type QuestionnaireSummary = {
    id: string;
    is_archived: boolean;
    description?: string;
    name: string;
    customer_type: QuestionnaireCustomerType;
};
export type QuestionnairesSummaryResponse = {
    questionnaire_summaries: QuestionnaireSummary[];
};
export type UpdateQuestionnaireRequest = {
    name: string;
    description?: string;
    title?: TranslationText;
    customer_type: QuestionnaireCustomerType;
    questions: CreateQuestionRequest[];
    is_archived?: boolean;
};
export type DataServiceQuestionnaireSubjectType = "BOTH" | "PERSON" | "LEGAL_ENTITY";
export type DataServiceQuestionType = "TEXT" | "YES_NO" | "SINGLE_CHOICE" | "MULTIPLE_CHOICE" | "SINGLE_COUNTRY_CHOICE" | "MULTIPLE_COUNTRY_CHOICE";
export type DataServiceCreateQuestionChoiceRequest = {
    text: TranslationText;
};
export type DataServiceCreateQuestionInfoboxRequest = {
    title: TranslationText;
    text: TranslationText;
};
export type DataServiceCreateQuestionRequest = {
    "type": DataServiceQuestionType;
    text: TranslationText;
    is_required: boolean;
    choices?: DataServiceCreateQuestionChoiceRequest[];
    infobox?: DataServiceCreateQuestionInfoboxRequest;
    show_infobox: boolean;
};
export type DataServiceCreateQuestionnaireRequest = {
    name: string;
    description?: string;
    title?: TranslationText;
    subject_type: DataServiceQuestionnaireSubjectType;
    questions: DataServiceCreateQuestionRequest[];
};
export type QuestionnairePreviewResponse = {
    preview_url: string;
    payload: DataServiceCreateQuestionnaireRequest;
};
export type MeasureConfig = {
    id: string;
    title: string;
    description: string;
    created_dt?: string;
    created_by?: User;
    updated_dt?: string;
    updated_by?: User;
    is_archived?: boolean;
    archived_dt?: string;
    archived_by?: User;
};
export type GlobalMeasureConfigList = {
    measure_configs: MeasureConfig[];
};
export type CreateUpdateGlobalMeasureConfigRequest = {
    title: string;
    description: string;
};
export type EmailNotificationFrequency = "NOT_SET" | "WEEKLY" | "MONTHLY";
export type FollowUpSettings = {
    /** Follow-up interval for low risk customers in months */
    low_risk_level_interval?: number;
    medium_risk_level_interval?: number;
    /** Follow-up interval for high risk customers in months */
    high_risk_level_interval?: number;
    email_notification_frequency: EmailNotificationFrequency;
};
export type UpdateFollowUpSettingsRequest = {
    /** Follow-up interval for low risk customers in months */
    low_risk_level_interval?: number;
    medium_risk_level_interval?: number;
    /** Follow-up interval for high risk customers in months */
    high_risk_level_interval?: number;
    email_notification_frequency: EmailNotificationFrequency;
};
export type BasicInfoUpdateNotificationFrequency = "IMMEDIATELY" | "DAILY" | "WEEKLY";
export type CustomerNotificationSettings = {
    /** Email notification frequency in days */
    email_notification_frequency: number;
    /** Maximum amount of notifications to send. If None, the system default is used */
    max_amount_of_notifications: number;
    /** The frequency of basic info updates. IMMEDIATELY will send individual emails per company update, while DAILY and WEEKLY will collate all emails over the period and send the notification in a single email. */
    basic_info_update_notification_frequency?: BasicInfoUpdateNotificationFrequency;
};
export type UpdateCustomerNotificationSettingsRequest = {
    /** Email notification frequency in days */
    email_notification_frequency: number;
    /** Maximum amount of notifications to send. If None, the system default is used */
    max_amount_of_notifications: number;
    /** The frequency of basic info updates. IMMEDIATELY will send individual emails per company update, while DAILY and WEEKLY will collate all emails over the period and send the notification in a single email. */
    basic_info_update_notification_frequency?: BasicInfoUpdateNotificationFrequency;
    /** Disable notifications for all customers */
    disable_notifications?: boolean;
};
export type OrganizationSignatureSettings = {
    use_verification: boolean;
    use_standard_disclosure: boolean;
    use_pep_disclosure?: boolean;
    language: LanguageEnum;
    send_email: boolean;
    questionnaire_ids: string[];
};
export type PersonOnboardingSettings = {
    screening_type: ScreeningType;
    signature_settings: OrganizationSignatureSettings;
};
export type UpdatePersonOnboardingSettingsRequest = {
    screening_type: ScreeningType;
    signature_settings: OrganizationSignatureSettings;
};
export type UpdateReviewSettingsRequest = {
    use_default_guideline: boolean;
};
export type ReviewSettings = {
    use_default_guideline: boolean;
};
export type ReviewChecklistListResponse = {
    checklists: ReviewChecklist[];
};
export type CreateReviewChecklistDisplaySettings = {
    risk_categories?: RiskCategory[];
    label_ids?: string[];
    assignment_purposes?: string[];
    assignment_industry_type?: string;
    is_always_select?: boolean;
    risk_levels?: RiskLevel[];
};
export type CreateReviewChecklistRequest = {
    name: string;
    description?: string;
    title?: TranslationText;
    is_required: boolean;
    customer_type: ReviewChecklistCustomerType;
    questions: ReviewChecklistQuestion[];
    display_settings?: CreateReviewChecklistDisplaySettings;
};
export type ReviewGuideline = {
    text_md: TranslationText;
    updated_by?: User;
    updated_dt?: string;
    title: TranslationText;
};
export type UpdateReviewGuidelineRequest = {
    text_md: TranslationText;
    title: TranslationText;
};
export type DisclosureSettings = {
    logo?: string;
    logo_filename?: string;
    person_intro_text?: TranslationText;
    company_intro_text?: TranslationText;
};
export type UpdateDisclosureSettingsRequest = {
    logo?: string;
    logo_filename?: string;
    person_intro_text?: TranslationText;
    company_intro_text?: TranslationText;
};
export type DataServiceDisclosureSettings = {
    logo?: string;
    logo_filename?: string;
    person_intro_text?: TranslationText;
    legal_entity_intro_text?: TranslationText;
};
export type DisclosureSettingsPreviewResponse = {
    preview_url: string;
    payload: DataServiceDisclosureSettings;
};
export type DashboardDateInterval = "DAILY" | "WEEKLY" | "MONTHLY" | "QUARTERLY" | "ANNUALLY" | "CUSTOM_DATE_RANGE";
export type DashboardCustomerType = "COMPANY" | "PERSON";
export type CustomerTypeMetric = {
    COMPANY: number;
    PERSON: number;
};
export type IndustryCodeMetric = {
    industry_code: string;
    industry_name: TranslationText;
    count: number;
};
export type IndustryCategories = {
    code: string;
    name: TranslationText;
};
export type IndustryCodeStatistics = {
    metrics: IndustryCodeMetric[];
    categories: IndustryCategories[];
};
export type RiskLevelMetric = {
    NOT_SET: number;
    LOW: number;
    MEDIUM: number;
    HIGH: number;
};
export type OnboardingStatusMetric = {
    DONE: number;
    FETCHING_DATA: number;
    READY: number;
    SCREENING_CONFIG: number;
    SIGNATURE_CONFIG: number;
    STARTED: number;
};
export type ReviewStatusMetric = {
    NOT_READY: number;
    REVIEW_REQUIRED: number;
    APPROVED: number;
    REJECTED: number;
};
export type RiskDataMetric = {
    HIGH_RISK_COUNTRY: number;
    CONSTRUCTION_INDUSTRY: number;
    HIGH_RISK_INDUSTRY: number;
    PEP: number;
    FINANCED_CRYPTO: number;
    FINANCED_CROWDFUNDING: number;
    MISSING_WORK_DOCUMENTATION: number;
    MISSING_FUNDING_DOCUMENTATION: number;
};
export type DashboardResponse = {
    customers_active_count: number;
    customers_approved_count: number;
    customers_pep_count: number;
    customers_sanctioned_count: number;
    customers_with_pending_tasks_count: number;
    customers_sanctioned_count_by_customer_type: CustomerTypeMetric;
    customers_pep_count_by_customer_type: CustomerTypeMetric;
    customers_count_by_industry_code: IndustryCodeStatistics;
    customers_count_by_risk_level: RiskLevelMetric;
    customers_count_by_customer_type: CustomerTypeMetric;
    customers_count_by_onboarding_status: OnboardingStatusMetric;
    customers_count_by_review_status: ReviewStatusMetric;
    customers_count_by_risk_data: RiskDataMetric;
    assignments_count_by_risk_data: RiskDataMetric;
    reviews_expired_count: number;
};
export type AssignmentIndustryPurpose = {
    label: TranslationText;
    value: string;
    is_deprecated: boolean;
};
export type AssignmentIndustry = {
    label: TranslationText;
    value: string;
    purposes: AssignmentIndustryPurpose[];
};
export type AssignmentIndustryDetails = {
    default_purposes: AssignmentIndustryPurpose[];
    industries: AssignmentIndustry[];
};
export type DecodedAuthToken = {
    "https://beaufort.io/email"?: string;
    "https://beaufort.io/name"?: string;
    "https://beaufort.io/given_name"?: string;
    "https://beaufort.io/family_name"?: string;
    iss: string;
    sub: string;
    aud: string | string[];
    iat: number;
    exp: number;
    azp?: string;
    gty?: string;
    scope?: string;
};
export type Organization = {
    id: string;
    name: string;
    country: CountryEnum;
};
export type AuthUser = {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    is_active: boolean;
    groups: Group[];
    organization: Organization;
    permissions?: string[];
    features?: {
        [key: string]: boolean;
    };
    available_languages?: string[];
};
export type HubspotIdentificationTokenGenerationRequest = {
    email: string;
    first_name: string;
    last_name: string;
};
export type HubspotIdentificationToken = {
    token: string;
};
export type SupportedCountriesEnum = "US" | "NL" | "FI" | "SE" | "NO" | "IS" | "SJ" | "DE" | "GL" | "DK" | "FO" | "BE";
export type PostalCodeResponseNavigation = {
    self: string;
    total_hits: number;
};
export type PostalCodeSuggestion = {
    city: string;
    county: string;
    latitude?: string;
    longitude?: string;
    municipality?: string;
    municipalityId?: string;
    po_box: boolean;
    postal_code: string;
};
export type BringPostalCodeLookupResponse = {
    navigation?: PostalCodeResponseNavigation;
    postal_codes?: PostalCodeSuggestion[];
};
export type StatusMessageSeverity = "INFO" | "WARNING" | "CRITICAL";
export type StatusMessageDetail = {
    id: number;
    message: string;
    severity: StatusMessageSeverity;
    start_time?: string;
    end_time?: string;
};
export type StatusMessageList = {
    status_messages: StatusMessageDetail[];
};
/**
 * Person Onboarding
 */
export function startPersonOnboarding(personOnboarding: PersonOnboarding, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: PersonOnboardingResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/onboarding/person", oazapfts.json({
        ...opts,
        method: "POST",
        body: personOnboarding
    })));
}
/**
 * Complete Company Onboarding
 */
export function completeCompanyOnboarding(companyOnboarding: CompanyOnboarding, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: CompleteCompanyOnboardingResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/onboarding/company", oazapfts.json({
        ...opts,
        method: "POST",
        body: companyOnboarding
    })));
}
/**
 * Get Customer By External Id
 */
export function getCustomerByExternalId(externalId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DataServicePersonSubjectDetailResponse | DataServiceLegalEntitySubjectDetailResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v1/customers/external-id/${encodeURIComponent(externalId)}`, {
        ...opts
    }));
}
/**
 * Delete Customer By External Id
 */
export function deleteCustomerByExternalId(externalId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v1/customers/external-id/${encodeURIComponent(externalId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Get Customer By National Id
 */
export function getCustomerByNationalId(getCustomerByNationalIdRequest: GetCustomerByNationalIdRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DataServicePersonDetail;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v1/customers/national-id", oazapfts.json({
        ...opts,
        method: "POST",
        body: getCustomerByNationalIdRequest
    })));
}
/**
 * Get Customer Updates
 */
export function getCustomerUpdates(customerId: string, start: string, end: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerUpdateEvents;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v1/customers/${encodeURIComponent(customerId)}/updates${QS.query(QS.explode({
        start,
        end
    }))}`, {
        ...opts
    }));
}
/**
 * Get Organization Updates
 */
export function getOrganizationUpdates(start: string, end: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: OrganizationCustomerUpdateEvents;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v1/organizations/updates${QS.query(QS.explode({
        start,
        end
    }))}`, {
        ...opts
    }));
}
/**
 * Get Internal Kyc Preview Link
 */
export function getInternalKycPreviewLink({ subjectId }: {
    subjectId?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/disclosures/kyc_preview_link${QS.query(QS.explode({
        subject_id: subjectId
    }))}`, {
        ...opts
    }));
}
/**
 * Get Disclosure Preview Link
 */
export function getDisclosurePreviewLink(signaturePreviewRequest: SignaturePreviewRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/disclosures/kyc_disclosure_preview_link", oazapfts.json({
        ...opts,
        method: "POST",
        body: signaturePreviewRequest
    })));
}
/**
 * Company Info
 */
export function getCompanyInfo(country: ValidCountriesEnum, nationalId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyInformationLookupResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/lookup/company/${encodeURIComponent(country)}/${encodeURIComponent(nationalId)}/info`, {
        ...opts
    }));
}
/**
 * Company Ownership
 */
export function getCompanyOwnership(country: ValidCountriesEnum, nationalId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyInformationOwnershipLookupResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/lookup/company/${encodeURIComponent(country)}/${encodeURIComponent(nationalId)}/ownership`, {
        ...opts
    }));
}
/**
 * Company Roles
 */
export function getCompanyRoles(country: ValidCountriesEnum, nationalId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyInformationRolesLookupResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/lookup/company/${encodeURIComponent(country)}/${encodeURIComponent(nationalId)}/roles`, {
        ...opts
    }));
}
/**
 * Country Risk And Tax Havens
 */
export function getCountryRiskAndTaxHavens({ date, source }: {
    date?: string;
    source?: DefinedCountryRiskSourceEnum;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CountryLookupResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/lookup/risk-countries${QS.query(QS.explode({
        date,
        source
    }))}`, {
        ...opts
    }));
}
/**
 * Industry Risk
 */
export function getIndustryRisk(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: IndustryRiskLookupResponse;
    } | {
        status: 401;
    }>("/v2/lookup/risk-industries", {
        ...opts
    }));
}
/**
 * Create Company Customer
 */
export function createCompanyCustomer(createCompanyCustomerRequest: CreateCompanyCustomerRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: CompanyCustomerDetailResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/customers/companies", oazapfts.json({
        ...opts,
        method: "POST",
        body: createCompanyCustomerRequest
    })));
}
/**
 * Create Person Customer
 */
export function createPersonCustomer(createPersonCustomerRequest: CreatePersonCustomerRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: PersonCustomerDetailResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/customers/persons", oazapfts.json({
        ...opts,
        method: "POST",
        body: createPersonCustomerRequest
    })));
}
/**
 * Get Person Customer Details
 */
export function getPersonCustomerDetails(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PersonCustomerDetailResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/persons/${encodeURIComponent(uuid)}`, {
        ...opts
    }));
}
/**
 * Update Person Customer
 */
export function updatePerson(uuid: string, updatePersonCustomerRequest: UpdatePersonCustomerRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PersonCustomer;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/persons/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updatePersonCustomerRequest
    })));
}
/**
 * Get Company Screening Configuration
 */
export function getCompanyScreeningConfiguration(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyScreeningConfiguration;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/screening`, {
        ...opts
    }));
}
/**
 * Put Company Screening Configuration
 */
export function updateCompanyScreeningConfiguration(uuid: string, putCompanyScreeningConfigurationRequest: PutCompanyScreeningConfigurationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyScreeningConfiguration;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/screening`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: putCompanyScreeningConfigurationRequest
    })));
}
/**
 * Patch Company Screening Configuration
 */
export function stopCompanyScreeningConfiguration(uuid: string, patchCompanyScreeningConfigurationRequest: PatchCompanyScreeningConfigurationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyScreeningConfiguration;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/screening`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: patchCompanyScreeningConfigurationRequest
    })));
}
/**
 * Stop Company Screening Configuration
 */
export function stopCompanyScreening(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/screening/stop`, {
        ...opts,
        method: "PUT"
    }));
}
/**
 * Stop Person Screening Configuration
 */
export function stopPersonScreening(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/persons/${encodeURIComponent(uuid)}/screening/stop`, {
        ...opts,
        method: "PUT"
    }));
}
/**
 * Get Person Screening Configuration
 */
export function getPersonScreeningConfiguration(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PersonScreeningConfiguration;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/persons/${encodeURIComponent(uuid)}/screening`, {
        ...opts
    }));
}
/**
 * Put Person Screening Configuration
 */
export function updatePersonScreeningConfiguration(uuid: string, personScreeningConfigurationRequest: PersonScreeningConfigurationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PersonScreeningConfiguration;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/persons/${encodeURIComponent(uuid)}/screening`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: personScreeningConfigurationRequest
    })));
}
/**
 * Patch Person Screening Configuration
 */
export function setPersonScreeningConfiguration(uuid: string, personScreeningConfigurationRequest: PersonScreeningConfigurationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PersonScreeningConfiguration;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/persons/${encodeURIComponent(uuid)}/screening`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: personScreeningConfigurationRequest
    })));
}
/**
 * Get Company Signature Configuration
 */
export function getCompanySignatureConfiguration(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanySignatureConfiguration;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/signatures`, {
        ...opts
    }));
}
/**
 * Put Company Signature Configuration
 */
export function updateCompanySignatureConfiguration(uuid: string, putCompanySignatureConfigurationRequest: PutCompanySignatureConfigurationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanySignatureConfiguration;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/signatures`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: putCompanySignatureConfigurationRequest
    })));
}
/**
 * Remind Signer
 */
export function remindSigner(uuid: string, signatureUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/signatures/${encodeURIComponent(signatureUuid)}/remind`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Get File Download Url
 */
export function getFileDownloadUrl(fileUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FileDownloadUrl;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/get_download_url/${encodeURIComponent(fileUuid)}`, {
        ...opts
    }));
}
/**
 * Get Customer List
 */
export function getCustomers({ limit, offset, $type, status, riskLevel, responsibleIds, responsibleUsers, ordering, createdAfter, createdBefore, screeningType, countryCode, labels, followUpAfter, followUpBefore, hasPendingDisclosures, hasPendingAttachments, hasPendingAssignments, q, industryCodes, isPep, isSanctioned, isArchived, unhandledOwnershipUpdates, isFollowUpExpired, hasUnresolvedCases, hasPendingMeasures, hasPendingTasks }: {
    limit?: number;
    offset?: number;
    $type?: string;
    status?: string;
    riskLevel?: string;
    responsibleIds?: string;
    responsibleUsers?: string;
    ordering?: string;
    createdAfter?: string;
    createdBefore?: string;
    screeningType?: ScreeningType;
    countryCode?: CountryEnum;
    labels?: string;
    followUpAfter?: string;
    followUpBefore?: string;
    hasPendingDisclosures?: boolean;
    hasPendingAttachments?: boolean;
    hasPendingAssignments?: boolean;
    q?: string;
    industryCodes?: string;
    isPep?: string;
    isSanctioned?: string;
    isArchived?: string;
    unhandledOwnershipUpdates?: string;
    isFollowUpExpired?: string;
    hasUnresolvedCases?: string;
    hasPendingMeasures?: string;
    hasPendingTasks?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: SearchResultResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${QS.query(QS.explode({
        limit,
        offset,
        "type": $type,
        status,
        risk_level: riskLevel,
        responsible_ids: responsibleIds,
        responsible_users: responsibleUsers,
        ordering,
        created_after: createdAfter,
        created_before: createdBefore,
        screening_type: screeningType,
        country_code: countryCode,
        labels,
        follow_up_after: followUpAfter,
        follow_up_before: followUpBefore,
        has_pending_disclosures: hasPendingDisclosures,
        has_pending_attachments: hasPendingAttachments,
        has_pending_assignments: hasPendingAssignments,
        q,
        industry_codes: industryCodes,
        is_pep: isPep,
        is_sanctioned: isSanctioned,
        is_archived: isArchived,
        unhandled_ownership_updates: unhandledOwnershipUpdates,
        is_follow_up_expired: isFollowUpExpired,
        has_unresolved_cases: hasUnresolvedCases,
        has_pending_measures: hasPendingMeasures,
        has_pending_tasks: hasPendingTasks
    }))}`, {
        ...opts
    }));
}
/**
 * Get Customer Counts
 */
export function getCustomerCounts({ limit, offset, $type, status, riskLevel, responsibleIds, responsibleUsers, ordering, createdAfter, createdBefore, screeningType, countryCode, labels, followUpAfter, followUpBefore, hasPendingDisclosures, hasPendingAttachments, hasPendingAssignments, q, industryCodes, isPep, isSanctioned, isArchived, unhandledOwnershipUpdates, isFollowUpExpired, hasUnresolvedCases, hasPendingMeasures, hasPendingTasks }: {
    limit?: number;
    offset?: number;
    $type?: string;
    status?: string;
    riskLevel?: string;
    responsibleIds?: string;
    responsibleUsers?: string;
    ordering?: string;
    createdAfter?: string;
    createdBefore?: string;
    screeningType?: ScreeningType;
    countryCode?: CountryEnum;
    labels?: string;
    followUpAfter?: string;
    followUpBefore?: string;
    hasPendingDisclosures?: boolean;
    hasPendingAttachments?: boolean;
    hasPendingAssignments?: boolean;
    q?: string;
    industryCodes?: string;
    isPep?: string;
    isSanctioned?: string;
    isArchived?: string;
    unhandledOwnershipUpdates?: string;
    isFollowUpExpired?: string;
    hasUnresolvedCases?: string;
    hasPendingMeasures?: string;
    hasPendingTasks?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerCountsResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/counts${QS.query(QS.explode({
        limit,
        offset,
        "type": $type,
        status,
        risk_level: riskLevel,
        responsible_ids: responsibleIds,
        responsible_users: responsibleUsers,
        ordering,
        created_after: createdAfter,
        created_before: createdBefore,
        screening_type: screeningType,
        country_code: countryCode,
        labels,
        follow_up_after: followUpAfter,
        follow_up_before: followUpBefore,
        has_pending_disclosures: hasPendingDisclosures,
        has_pending_attachments: hasPendingAttachments,
        has_pending_assignments: hasPendingAssignments,
        q,
        industry_codes: industryCodes,
        is_pep: isPep,
        is_sanctioned: isSanctioned,
        is_archived: isArchived,
        unhandled_ownership_updates: unhandledOwnershipUpdates,
        is_follow_up_expired: isFollowUpExpired,
        has_unresolved_cases: hasUnresolvedCases,
        has_pending_measures: hasPendingMeasures,
        has_pending_tasks: hasPendingTasks
    }))}`, {
        ...opts
    }));
}
/**
 * Get Customer Details
 */
export function getCustomerDetails(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyCustomerDetailResponse | PersonCustomerDetailResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}`, {
        ...opts
    }));
}
/**
 * Delete Customer
 */
export function archiveCustomer(uuid: string, { purge }: {
    purge?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}${QS.query(QS.explode({
        purge
    }))}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Update Customer Details
 */
export function updateCustomerDetails(uuid: string, updateCustomerRequest: UpdateCustomerRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyCustomerDetailResponse | PersonCustomerDetailResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateCustomerRequest
    })));
}
/**
 * Get Company Customer Details
 */
export function getCompanyCustomerDetails(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyCustomerDetailResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}`, {
        ...opts
    }));
}
/**
 * Update Company Customer
 */
export function updateCompanyCustomer(uuid: string, updateCompanyCustomerRequest: UpdateCompanyCustomerRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyCustomer;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateCompanyCustomerRequest
    })));
}
/**
 * Quick Review Company Info Update
 */
export function quickReviewCompanyInfoUpdate(uuid: string, infoUpdateId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/info-updates/${encodeURIComponent(infoUpdateId)}/quick-review`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Get Customer Matches
 */
export function getCustomerMatches(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: MatchListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/matches`, {
        ...opts
    }));
}
/**
 * Get Customer Match Detail
 */
export function getCustomerMatchDetails(uuid: string, matchId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: MatchDetailResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/matches/${encodeURIComponent(matchId)}`, {
        ...opts
    }));
}
/**
 * Get Customer Match Cases
 */
export function getCustomerMatchCases(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: MatchCaseListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/match-cases`, {
        ...opts
    }));
}
/**
 * Get Customer Match Case Detail
 */
export function getCustomerMatchCaseDetails(uuid: string, caseId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: MatchCaseDetailResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/match-cases/${encodeURIComponent(caseId)}`, {
        ...opts
    }));
}
/**
 * Create Match Review
 */
export function createMatchReview(uuid: string, caseId: string, createMatchReviewRequest: CreateMatchReviewRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: MatchReview;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/match-cases/${encodeURIComponent(caseId)}/reviews`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createMatchReviewRequest
    })));
}
/**
 * Create Customer Review
 */
export function createCustomerReview(uuid: string, createCustomerReviewRequest: CreateCustomerReviewRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: CustomerReview;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/reviews`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createCustomerReviewRequest
    })));
}
/**
 * Update Customer Review
 */
export function updateCustomerReview(uuid: string, reviewUuid: string, updateCustomerReviewRequest: UpdateCustomerReviewRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerReview;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateCustomerReviewRequest
    })));
}
/**
 * Create Draft Customer Review
 */
export function createDraftCustomerReview(uuid: string, createDraftCustomerReviewRequest: CreateDraftCustomerReviewRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DraftCustomerReview;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/draft_reviews/`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createDraftCustomerReviewRequest
    })));
}
/**
 * Update Draft Customer Review
 */
export function updateDraftCustomerReview(uuid: string, reviewUuid: string, updateDraftCustomerReviewRequest: UpdateDraftCustomerReviewRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DraftCustomerReview;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/draft_reviews/${encodeURIComponent(reviewUuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateDraftCustomerReviewRequest
    })));
}
/**
 * Delete Customer Review
 */
export function deleteCustomerReview(uuid: string, reviewId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Approve Customer Review
 */
export function approveCustomerReview(uuid: string, reviewUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: CustomerReviewApproval;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}/approve`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Reject Customer Review
 */
export function rejectCustomerReview(uuid: string, reviewUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: CustomerReviewApproval;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}/reject`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Create Customer Review Measure
 */
export function addCustomerReviewMeasure(uuid: string, reviewUuid: string, createMeasureRequest: CreateMeasureRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Measure;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}/measures`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createMeasureRequest
    })));
}
/**
 * Update Customer Review Measure
 */
export function updateCustomerReviewMeasure(uuid: string, reviewUuid: string, measureUuid: string, updateMeasureRequest: UpdateMeasureRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Measure;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}/measures/${encodeURIComponent(measureUuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateMeasureRequest
    })));
}
/**
 * Remove Customer Review Measure
 */
export function removeCustomerReviewMeasure(uuid: string, reviewUuid: string, measureUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}/measures/${encodeURIComponent(measureUuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Move Customer Review Measure
 */
export function moveCustomerReviewMeasure(uuid: string, reviewUuid: string, measureUuid: string, moveMeasureRequest: MoveMeasureRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}/measures/${encodeURIComponent(measureUuid)}/move`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: moveMeasureRequest
    })));
}
/**
 * Start Company Screening
 */
export function startCompanyScreening(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/screening/start`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Start Person Screening
 */
export function startPersonScreening(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/persons/${encodeURIComponent(uuid)}/screening/start`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Finish Onboarding
 */
export function finishOnboarding(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/onboarding/finish`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Cancel Onboarding
 */
export function cancelOnboarding(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/onboarding/cancel`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Create Company Role
 */
export function createCompanyRole(uuid: string, createRoleRequest: CreateRoleRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Role;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/roles`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createRoleRequest
    })));
}
/**
 * Sync Company Role
 */
export function syncCompanyRole(uuid: string, syncRoleRequest: SyncRoleRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Role;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/sync_role`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: syncRoleRequest
    })));
}
/**
 * Sync Company Owner
 */
export function syncCompanyOwner(uuid: string, syncOwnerRequest: SyncOwnerRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Owner;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/sync_owner`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: syncOwnerRequest
    })));
}
/**
 * Delete Company Role
 */
export function deleteCompanyRole(uuid: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Update Company Role
 */
export function updateCompanyRole(uuid: string, roleId: string, updateRoleRequest: UpdateRoleRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Role;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/roles/${encodeURIComponent(roleId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateRoleRequest
    })));
}
/**
 * Create Company Owner
 */
export function createCompanyOwner(uuid: string, createOwnerRequest: CreateOwnerRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Owner;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/owners`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createOwnerRequest
    })));
}
/**
 * Delete Company Owner
 */
export function deleteCompanyOwner(uuid: string, ownerId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/owners/${encodeURIComponent(ownerId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Update Company Owner
 */
export function updateCompanyOwner(uuid: string, ownerId: string, updateOwnerRequest: UpdateOwnerRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Owner;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/owners/${encodeURIComponent(ownerId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateOwnerRequest
    })));
}
/**
 * Get Person Signature Configuration
 */
export function getPersonSignatureConfiguration(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PersonSignatureConfiguration;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/persons/${encodeURIComponent(uuid)}/signatures`, {
        ...opts
    }));
}
/**
 * Patch Person Signature Configuration
 */
export function setPersonSignatureConfiguration(uuid: string, patchPersonSignatureConfigurationRequest: PatchPersonSignatureConfigurationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PersonSignatureConfiguration;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/persons/${encodeURIComponent(uuid)}/signatures`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: patchPersonSignatureConfigurationRequest
    })));
}
/**
 * Patch Person Signature
 */
export function updatePersonSignature(uuid: string, signatureId: string, updateSignatureRequest: UpdateSignatureRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Signature;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/persons/${encodeURIComponent(uuid)}/signatures/${encodeURIComponent(signatureId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateSignatureRequest
    })));
}
/**
 * Patch Company Signature
 */
export function updateCompanySignature(uuid: string, signatureId: string, updateSignatureRequest: UpdateSignatureRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Signature;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/signatures/${encodeURIComponent(signatureId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateSignatureRequest
    })));
}
/**
 * Create Company Customer Match Review
 */
export function createCompanyCustomerMatchReview(uuid: string, caseId: string, createMatchReviewRequest: CreateMatchReviewRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: MatchReview;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/match-cases/${encodeURIComponent(caseId)}/reviews`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createMatchReviewRequest
    })));
}
/**
 * Delete Customer Signature
 */
export function deleteCustomerSignature(uuid: string, signatureId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/signatures/${encodeURIComponent(signatureId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Get Report For Customer
 */
export function getCustomerReport(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/report`, {
        ...opts
    }));
}
/**
 * Get Screening Report For Customer
 */
export function getScreeningReport(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/screening_report`, {
        ...opts
    }));
}
/**
 * Create Company Customer Disclosure Document
 */
export function createCompanyCustomerDisclosureDocument(uuid: string, createCompanyCustomerDisclosureDocumentRequest: CreateCompanyCustomerDisclosureDocumentRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: CustomerDisclosureDocument;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/disclosure-documents`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createCompanyCustomerDisclosureDocumentRequest
    })));
}
/**
 * Create Person Customer Disclosure Document
 */
export function createPersonCustomerDisclosureDocument(uuid: string, createPersonCustomerDisclosureDocumentRequest: CreatePersonCustomerDisclosureDocumentRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: CustomerDisclosureDocument;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/persons/${encodeURIComponent(uuid)}/disclosure-documents`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createPersonCustomerDisclosureDocumentRequest
    })));
}
/**
 * Download Customer Attachment
 */
export function downloadCustomerAttachment(uuid: string, attachmentUuid: any, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AttachmentDownloadUrl;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/download`, {
        ...opts
    }));
}
/**
 * Get Customer Attachment List
 */
export function getCustomerAttachments(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AttachmentDetailsList;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/attachments`, {
        ...opts
    }));
}
/**
 * Generate Customer Attachment Metadata
 */
export function addCustomerAttachment(uuid: string, createAttachmentMetadataRequest: CreateAttachmentMetadataRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: AttachmentDetails;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/attachments`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createAttachmentMetadataRequest
    })));
}
/**
 * Delete Customer Attachment
 */
export function deleteCustomerAttachment(uuid: string, attachmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Get Customer Attachment Signatures
 */
export function getAttachmentSignatures(uuid: string, attachmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AttachmentSignaturesResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signatures`, {
        ...opts
    }));
}
/**
 * Update Customer Attachment Signatures
 */
export function updateAttachmentSignatures(uuid: string, attachmentUuid: string, updateAttachmentSignaturesRequest: UpdateAttachmentSignaturesRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AttachmentSignaturesResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signatures`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateAttachmentSignaturesRequest
    })));
}
/**
 * Download Signed Customer Attachment
 */
export function downloadSignedCustomerAttachment(uuid: string, attachmentUuid: any, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signed_document`, {
        ...opts
    }));
}
/**
 * Delete Signed Customer Attachment
 */
export function deleteSignedCustomerAttachment(uuid: string, attachmentUuid: any, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signed_document`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Batch Set Follow Up Date On Customers
 */
export function batchSetFollowUpDateOnCustomers(batchSetFollowUpDateOnCustomersRequest: BatchSetFollowUpDateOnCustomersRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/customers/batch/follow_up_date", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: batchSetFollowUpDateOnCustomersRequest
    })));
}
/**
 * Batch Set Responsible Users On Customers
 */
export function batchSetResponsibleUsersOnCustomers(batchSetResponsibleUsersOnCustomers: BatchSetResponsibleUsersOnCustomers, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/customers/batch/responsible_users", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: batchSetResponsibleUsersOnCustomers
    })));
}
/**
 * Archive Customers
 */
export function archiveCustomers(batchCustomersRequestBase: BatchCustomersRequestBase, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/customers/batch/archive", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: batchCustomersRequestBase
    })));
}
/**
 * Delete Customers
 */
export function deleteCustomers(batchCustomersRequestBase: BatchCustomersRequestBase, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/customers/batch/delete", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: batchCustomersRequestBase
    })));
}
/**
 * Restore Customers
 */
export function restoreCustomers(batchCustomersRequestBase: BatchCustomersRequestBase, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/customers/batch/restore", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: batchCustomersRequestBase
    })));
}
/**
 * Batch Assign Labels To Customers
 */
export function batchAssignLabelsToCustomers(labelsOnTargets: LabelsOnTargets, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/customers/batch/assign-label", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelsOnTargets
    })));
}
/**
 * Batch Set Labels To Customers
 */
export function batchSetLabelsOnCustomers(labelsOnTargets: LabelsOnTargets, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/customers/batch/set-label", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelsOnTargets
    })));
}
/**
 * Batch Create And Assign Label To Customers
 */
export function batchCreateAndAssignLabelOnCustomers(titleOnTargets: TitleOnTargets, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/customers/batch/create-and-assign-label", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: titleOnTargets
    })));
}
/**
 * Batch Unassign Labels From Customers
 */
export function batchUnassignLabelsFromCustomers(labelsOnTargets: LabelsOnTargets, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/customers/batch/unassign-labels", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelsOnTargets
    })));
}
/**
 * Confirm Ownership Update
 */
export function confirmOwnershipUpdate(uuid: any, updateId: any, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Owner;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/ownership_updates/${encodeURIComponent(updateId)}/confirm`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Reject Ownership Update
 */
export function rejectOwnershipUpdate(uuid: any, updateId: any, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/ownership_updates/${encodeURIComponent(updateId)}/reject`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Confirm All Ownership Updates
 */
export function confirmAllOwnershipUpdates(uuid: any, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ConfirmAllOwnershipUpdatesResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(uuid)}/ownership_updates/confirm_all`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Create Customer Assignment
 */
export function createCustomerAssignment(customerUuid: string, createOrUpdateAssignmentRequest: CreateOrUpdateAssignmentRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Assignment;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createOrUpdateAssignmentRequest
    })));
}
/**
 * Get Customer Assignment Details
 */
export function getCustomerAssignmentDetails(customerUuid: string, assignmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerAssignmentDetails;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}`, {
        ...opts
    }));
}
/**
 * Update Customer Assignment
 */
export function updateCustomerAssignment(customerUuid: string, assignmentUuid: string, createOrUpdateAssignmentRequest: CreateOrUpdateAssignmentRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Assignment;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: createOrUpdateAssignmentRequest
    })));
}
/**
 * Archive Customer Assignment
 */
export function archiveCustomerAssignment(customerUuid: string, assignmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Restore Customer Assignment
 */
export function restoreCustomerAssignment(customerUuid: string, assignmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Assignment;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/restore`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Create Customer Assignment Review
 */
export function createCustomerAssignmentReview(customerUuid: string, assignmentUuid: string, createAssignmentReviewRequest: CreateAssignmentReviewRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: AssignmentReview;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/reviews`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createAssignmentReviewRequest
    })));
}
/**
 * Download Customer Assignment Attachment
 */
export function downloadCustomerAssignmentAttachment(customerUuid: string, assignmentUuid: string, attachmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AttachmentDownloadUrl;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments/${encodeURIComponent(attachmentUuid)}/download`, {
        ...opts
    }));
}
/**
 * Get Customer Assignment Attachment List
 */
export function getCustomerAssignmentAttachments(customerUuid: string, assignmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AttachmentDetailsList;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments`, {
        ...opts
    }));
}
/**
 * Generate Customer Assignment Attachment Metadata
 */
export function addCustomerAssignmentAttachment(customerUuid: string, assignmentUuid: string, createAttachmentMetadataRequest: CreateAttachmentMetadataRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: AttachmentDetails;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createAttachmentMetadataRequest
    })));
}
/**
 * Delete Customer Assignment Attachment
 */
export function deleteCustomerAssignmentAttachment(customerUuid: string, assignmentUuid: string, attachmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments/${encodeURIComponent(attachmentUuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Get Customer Assignment Attachment Signatures
 */
export function getCustomerAssignmentAttachmentSignatures(customerUuid: string, assignmentUuid: string, attachmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AttachmentSignaturesResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signatures`, {
        ...opts
    }));
}
/**
 * Update Customer Assignment Attachment Signatures
 */
export function updateCustomerAssignmentAttachmentSignatures(customerUuid: string, assignmentUuid: string, attachmentUuid: string, updateAttachmentSignaturesRequest: UpdateAttachmentSignaturesRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AttachmentSignaturesResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signatures`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateAttachmentSignaturesRequest
    })));
}
/**
 * Download Signed Customer Assignment Attachment
 */
export function downloadSignedCustomerAssignmentAttachment(customerUuid: string, assignmentUuid: string, attachmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signed_document`, {
        ...opts
    }));
}
/**
 * Delete Signed Customer Assignment Attachment
 */
export function deleteSignedCustomerAssignmentAttachment(customerUuid: string, assignmentUuid: string, attachmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signed_document`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Get Customer Ownership Tree
 */
export function getCustomerOwnershipTree(customerUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: OwnershipTreeResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerUuid)}/ownership_tree`, {
        ...opts
    }));
}
/**
 * Get Company Ownership Tree
 */
export function getCompanyOwnershipTree(companyUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: OwnershipTreeResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/companies/${encodeURIComponent(companyUuid)}/ownership_tree`, {
        ...opts
    }));
}
/**
 * List Customer Notations
 */
export function listCustomerNotations(customerId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerNotation[];
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerId)}/notations`, {
        ...opts
    }));
}
/**
 * Create Customer Notation
 */
export function createCustomerNotation(customerId: string, baseNotation: BaseNotation, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: CustomerNotation;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerId)}/notations`, oazapfts.json({
        ...opts,
        method: "POST",
        body: baseNotation
    })));
}
/**
 * Get Customer Notation
 */
export function getCustomerNotation(customerId: string, notationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerNotation;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerId)}/notations/${encodeURIComponent(notationId)}`, {
        ...opts
    }));
}
/**
 * Update Customer Notation
 */
export function updateCustomerNotation(customerId: string, notationId: string, baseNotation: BaseNotation, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerNotation;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerId)}/notations/${encodeURIComponent(notationId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: baseNotation
    })));
}
/**
 * Delete Customer Notation
 */
export function deleteCustomerNotation(customerId: string, notationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerId)}/notations/${encodeURIComponent(notationId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * List Customer Review Notations
 */
export function listCustomerReviewNotations(customerId: string, reviewId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerReviewNotation[];
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerId)}/reviews/${encodeURIComponent(reviewId)}/notations`, {
        ...opts
    }));
}
/**
 * Create Customer Review Notation
 */
export function createCustomerReviewNotation(customerId: string, reviewId: string, baseNotation: BaseNotation, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: CustomerReviewNotation;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerId)}/reviews/${encodeURIComponent(reviewId)}/notations`, oazapfts.json({
        ...opts,
        method: "POST",
        body: baseNotation
    })));
}
/**
 * Get Customer Review Notation
 */
export function getCustomerReviewNotation(customerId: string, reviewId: string, notationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerReviewNotation;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerId)}/reviews/${encodeURIComponent(reviewId)}/notations/${encodeURIComponent(notationId)}`, {
        ...opts
    }));
}
/**
 * Update Customer Review Notation
 */
export function updateCustomerReviewNotation(customerId: string, reviewId: string, notationId: string, baseNotation: BaseNotation, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerReviewNotation;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerId)}/reviews/${encodeURIComponent(reviewId)}/notations/${encodeURIComponent(notationId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: baseNotation
    })));
}
/**
 * Delete Customer Review Notation
 */
export function deleteCustomerReviewNotation(customerId: string, reviewId: string, notationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerId)}/reviews/${encodeURIComponent(reviewId)}/notations/${encodeURIComponent(notationId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * List Kar Lookups
 */
export function listKarLookups(customerId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: KarLookupResultList;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerId)}/kar_lookup`, {
        ...opts
    }));
}
/**
 * Create Kar Lookup
 */
export function createKarLookup(customerId: string, karLookupRequest: KarLookupRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: KarLookupResult;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/customers/${encodeURIComponent(customerId)}/kar_lookup`, oazapfts.json({
        ...opts,
        method: "POST",
        body: karLookupRequest
    })));
}
/**
 * Get Project List
 */
export function getProjects({ limit, offset, status, q, responsibleIds, responsibleUsers, createdAfter, createdBefore, ordering, isVitec }: {
    limit?: number;
    offset?: number;
    status?: string;
    q?: string;
    responsibleIds?: string;
    responsibleUsers?: string;
    createdAfter?: string;
    createdBefore?: string;
    ordering?: string;
    isVitec?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ProjectList;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${QS.query(QS.explode({
        limit,
        offset,
        status,
        q,
        responsible_ids: responsibleIds,
        responsible_users: responsibleUsers,
        created_after: createdAfter,
        created_before: createdBefore,
        ordering,
        is_vitec: isVitec
    }))}`, {
        ...opts
    }));
}
/**
 * Create Project
 */
export function createProject(createProjectRequest: CreateProjectRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Project;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/projects/", oazapfts.json({
        ...opts,
        method: "POST",
        body: createProjectRequest
    })));
}
/**
 * Get Project
 */
export function getProject(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Project;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(uuid)}`, {
        ...opts
    }));
}
/**
 * Update Project
 */
export function updateProject(uuid: string, updateProjectRequest: UpdateProjectRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Project;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateProjectRequest
    })));
}
/**
 * Get Project Customers Details
 */
export function getProjectCustomersDetails(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ProjectCustomersDetails;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(uuid)}/customers`, {
        ...opts
    }));
}
/**
 * Create Project Review
 */
export function createProjectReview(uuid: string, createProjectReviewRequest: CreateProjectReviewRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: ProjectReview;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(uuid)}/reviews`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createProjectReviewRequest
    })));
}
/**
 * Get Project Attachment List
 */
export function getProjectAttachments(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AttachmentDetailsList;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(uuid)}/attachments`, {
        ...opts
    }));
}
/**
 * Generate Project Attachment Metadata
 */
export function addProjectAttachment(uuid: string, createAttachmentMetadataRequest: CreateAttachmentMetadataRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: AttachmentDetails;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(uuid)}/attachments`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createAttachmentMetadataRequest
    })));
}
/**
 * Download Project Attachment
 */
export function downloadProjectAttachment(uuid: string, attachmentUuid: any, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/download`, {
        ...opts
    }));
}
/**
 * Delete Project Attachment
 */
export function deleteProjectAttachment(uuid: string, attachmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Get Project Attachment Signatures
 */
export function getProjectAttachmentSignatures(uuid: string, attachmentUuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AttachmentSignaturesResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signatures`, {
        ...opts
    }));
}
/**
 * Update Project Attachment Signatures
 */
export function updateProjectAttachmentSignatures(uuid: string, attachmentUuid: string, updateAttachmentSignaturesRequest: UpdateAttachmentSignaturesRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AttachmentSignaturesResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signatures`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateAttachmentSignaturesRequest
    })));
}
/**
 * Download Signed Project Attachment
 */
export function downloadSignedProjectAttachment(uuid: string, attachmentUuid: any, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signed_document`, {
        ...opts
    }));
}
/**
 * Delete Signed Project Attachment
 */
export function deleteSignedProjectAttachment(uuid: string, attachmentUuid: any, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signed_document`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Batch Assign Labels To Project Customers
 */
export function batchAssignLabelsToProjectCustomers(projectUuid: string, labelsOnTargets: LabelsOnTargets, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(projectUuid)}/batch-assign-label-to-customers`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelsOnTargets
    })));
}
/**
 * Batch Set Labels To Project Customers
 */
export function batchSetLabelsOnProjectCustomers(projectUuid: string, labelsOnTargets: LabelsOnTargets, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(projectUuid)}/batch-set-label-on-customers`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelsOnTargets
    })));
}
/**
 * Batch Create And Assign Label To Project Customers
 */
export function batchCreateAndAssignLabelOnProjectCustomers(projectUuid: string, titleOnTargets: TitleOnTargets, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(projectUuid)}/batch-create-and-assign-label-on-customers`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: titleOnTargets
    })));
}
/**
 * Batch Unassign Labels From Project Customers
 */
export function batchUnassignLabelsFromProjectCustomers(projectUuid: string, labelsOnTargets: LabelsOnTargets, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerListResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/projects/${encodeURIComponent(projectUuid)}/batch-unassign-labels-from-customers`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelsOnTargets
    })));
}
/**
 * Generate Attachment Upload Id And Url
 */
export function generateAttachmentUploadIdAndUrl(attachmentUploadRequest: AttachmentUploadRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AttachmentUploadResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/attachments/upload", oazapfts.json({
        ...opts,
        method: "POST",
        body: attachmentUploadRequest
    })));
}
/**
 * List Users
 */
export function getAllUsersAndGroups(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: UserListResponse;
    } | {
        status: 401;
    }>("/v2/users/", {
        ...opts
    }));
}
/**
 * Create User
 */
export function createUser(createUserRequest: CreateUserRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: User;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/users/", oazapfts.json({
        ...opts,
        method: "POST",
        body: createUserRequest
    })));
}
/**
 * Update User
 */
export function updateUser(uuid: any, updateUserRequest: UpdateUserRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/users/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateUserRequest
    })));
}
/**
 * List Labels
 */
export function getAllLabels({ q }: {
    q?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LabelList;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/labels/${QS.query(QS.explode({
        q
    }))}`, {
        ...opts
    }));
}
/**
 * Create Label
 */
export function createLabel(labelData: LabelData, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Label;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/labels/", oazapfts.json({
        ...opts,
        method: "POST",
        body: labelData
    })));
}
/**
 * Delete Label
 */
export function deleteLabel(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/labels/${encodeURIComponent(uuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Update Label
 */
export function updateLabel(uuid: string, labelData: LabelData, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Label;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/labels/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelData
    })));
}
/**
 * Get All Industry Codes
 */
export function listAllIndustryCodes(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: NaceIndustryCodesList;
    } | {
        status: 401;
    }>("/v2/labels/industry-codes/", {
        ...opts
    }));
}
/**
 * List Questionnaires
 */
export function listQuestionnaires(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: QuestionnaireListResponse;
    } | {
        status: 401;
    }>("/v2/questionnaires/", {
        ...opts
    }));
}
/**
 * Create Questionnaire
 */
export function createQuestionnaire(createQuestionnaireRequest: CreateQuestionnaireRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Questionnaire;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/questionnaires/", oazapfts.json({
        ...opts,
        method: "POST",
        body: createQuestionnaireRequest
    })));
}
/**
 * Questionnaires Summary
 */
export function getQuestionnairesSummary(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: QuestionnairesSummaryResponse;
    } | {
        status: 401;
    }>("/v2/questionnaires/summary", {
        ...opts
    }));
}
/**
 * Get Questionnaire
 */
export function getQuestionnaire(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Questionnaire;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/questionnaires/${encodeURIComponent(uuid)}`, {
        ...opts
    }));
}
/**
 * Update Questionnaire
 */
export function updateQuestionnaire(uuid: string, updateQuestionnaireRequest: UpdateQuestionnaireRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Questionnaire;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/questionnaires/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateQuestionnaireRequest
    })));
}
/**
 * Archive Questionnaire
 */
export function archiveQuestionnaire(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/questionnaires/${encodeURIComponent(uuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Generate Questionnaire Preview Request
 */
export function generateQuestionnairePreviewRequest(createQuestionnaireRequest: CreateQuestionnaireRequest, { customerType }: {
    customerType?: CustomerType;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: QuestionnairePreviewResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/questionnaires/preview${QS.query(QS.explode({
        customer_type: customerType
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createQuestionnaireRequest
    })));
}
/**
 * Get Measure Configs
 */
export function getGlobalMeasureConfigs(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: GlobalMeasureConfigList;
    } | {
        status: 401;
    }>("/v2/measures/", {
        ...opts
    }));
}
/**
 * Create Measure Config
 */
export function createGlobalMeasureConfig(createUpdateGlobalMeasureConfigRequest: CreateUpdateGlobalMeasureConfigRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: MeasureConfig;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/measures/", oazapfts.json({
        ...opts,
        method: "POST",
        body: createUpdateGlobalMeasureConfigRequest
    })));
}
/**
 * Update Measure Config
 */
export function updateGlobalMeasureConfig(uuid: string, createUpdateGlobalMeasureConfigRequest: CreateUpdateGlobalMeasureConfigRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: MeasureConfig;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/measures/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: createUpdateGlobalMeasureConfigRequest
    })));
}
/**
 * Archive Measure Config
 */
export function archiveGlobalMeasureConfig(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/measures/${encodeURIComponent(uuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Move Measure Config
 */
export function moveGlobalMeasureConfig(uuid: string, moveMeasureRequest: MoveMeasureRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/measures/${encodeURIComponent(uuid)}/move`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: moveMeasureRequest
    })));
}
/**
 * Get Follow Up Settings
 */
export function getFollowUpSettings(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FollowUpSettings;
    } | {
        status: 401;
    }>("/v2/organizations/settings/follow_up", {
        ...opts
    }));
}
/**
 * Update Follow Up Settings
 */
export function updateFollowUpSettings(updateFollowUpSettingsRequest: UpdateFollowUpSettingsRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FollowUpSettings;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/organizations/settings/follow_up", oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateFollowUpSettingsRequest
    })));
}
/**
 * Get Customer Notification Settings
 */
export function getCustomerNotificationSettings(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerNotificationSettings;
    } | {
        status: 401;
    }>("/v2/organizations/settings/customer_notifications", {
        ...opts
    }));
}
/**
 * Update Customer Notification Settings
 */
export function updateCustomerNotificationSettings(updateCustomerNotificationSettingsRequest: UpdateCustomerNotificationSettingsRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CustomerNotificationSettings;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/organizations/settings/customer_notifications", oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateCustomerNotificationSettingsRequest
    })));
}
/**
 * Get Person Onboarding Settings
 */
export function getPersonOnboardingSettings(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PersonOnboardingSettings;
    } | {
        status: 401;
    }>("/v2/organizations/settings/onboarding/person", {
        ...opts
    }));
}
/**
 * Update Person Onboarding Settings
 */
export function updatePersonOnboardingSettings(updatePersonOnboardingSettingsRequest: UpdatePersonOnboardingSettingsRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PersonOnboardingSettings;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/organizations/settings/onboarding/person", oazapfts.json({
        ...opts,
        method: "PUT",
        body: updatePersonOnboardingSettingsRequest
    })));
}
/**
 * Update Review Settings
 */
export function updateReviewSettings(updateReviewSettingsRequest: UpdateReviewSettingsRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ReviewSettings;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/organizations/settings/review", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateReviewSettingsRequest
    })));
}
/**
 * Get All Review Checklists
 */
export function getReviewChecklists(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ReviewChecklistListResponse;
    } | {
        status: 401;
    }>("/v2/organizations/settings/review/checklists", {
        ...opts
    }));
}
/**
 * Create Review Checklist
 */
export function createReviewChecklist(createReviewChecklistRequest: CreateReviewChecklistRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ReviewChecklist;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/organizations/settings/review/checklists", oazapfts.json({
        ...opts,
        method: "POST",
        body: createReviewChecklistRequest
    })));
}
/**
 * Get Review Checklist
 */
export function getReviewChecklist(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ReviewChecklist;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/organizations/settings/review/checklists/${encodeURIComponent(uuid)}`, {
        ...opts
    }));
}
/**
 * Update Review Checklist
 */
export function updateReviewChecklist(uuid: string, createReviewChecklistRequest: CreateReviewChecklistRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ReviewChecklist;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/organizations/settings/review/checklists/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: createReviewChecklistRequest
    })));
}
/**
 * Archive Review Checklist
 */
export function archiveReviewChecklist(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/organizations/settings/review/checklists/${encodeURIComponent(uuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Restore Review Checklist
 */
export function restoreReviewChecklist(uuid: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: any;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/organizations/settings/review/checklists/${encodeURIComponent(uuid)}/restore`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Get Review Guideline
 */
export function getReviewGuideline(customerType: CustomerType, { timestamp }: {
    timestamp?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ReviewGuideline;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/organizations/settings/review-guideline/${encodeURIComponent(customerType)}${QS.query(QS.explode({
        timestamp
    }))}`, {
        ...opts
    }));
}
/**
 * Update Review Guideline
 */
export function updateReviewGuideline(customerType: CustomerType, updateReviewGuidelineRequest: UpdateReviewGuidelineRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ReviewGuideline;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/organizations/settings/review-guideline/${encodeURIComponent(customerType)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateReviewGuidelineRequest
    })));
}
/**
 * Get Disclosure Settings
 */
export function getDisclosureSettings(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DisclosureSettings;
    } | {
        status: 401;
    }>("/v2/organizations/settings/disclosure", {
        ...opts
    }));
}
/**
 * Update Disclosure Settings
 */
export function updateDisclosureSettings(updateDisclosureSettingsRequest: UpdateDisclosureSettingsRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DisclosureSettings;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/organizations/settings/disclosure", oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateDisclosureSettingsRequest
    })));
}
/**
 * Preview Disclosure Settings
 */
export function previewDisclosureSettings(disclosureSettings: DisclosureSettings, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DisclosureSettingsPreviewResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/v2/organizations/settings/disclosure/preview", oazapfts.json({
        ...opts,
        method: "POST",
        body: disclosureSettings
    })));
}
/**
 * Get Dashboard
 */
export function getDashboard({ includeArchivedCustomers, interval, customerType, startDate, endDate, project, labelIds, responsibleUserIds }: {
    includeArchivedCustomers?: boolean;
    interval?: DashboardDateInterval;
    customerType?: DashboardCustomerType;
    startDate?: string;
    endDate?: string;
    project?: string;
    labelIds?: string[];
    responsibleUserIds?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DashboardResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/v2/dashboard/${QS.query(QS.explode({
        include_archived_customers: includeArchivedCustomers,
        interval,
        customer_type: customerType,
        start_date: startDate,
        end_date: endDate,
        project,
        label_ids: labelIds,
        responsible_user_ids: responsibleUserIds
    }))}`, {
        ...opts
    }));
}
/**
 * Get Assignment Industries
 */
export function getAssignmentIndustries(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AssignmentIndustryDetails;
    } | {
        status: 401;
    }>("/v2/assignments/industries", {
        ...opts
    }));
}
/**
 * Auth verification
 */
export function getWhoAmI(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DecodedAuthToken;
    } | {
        status: 401;
    }>("/auth/whoami", {
        ...opts
    }));
}
/**
 * User auth
 */
export function getLoggedInUser(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AuthUser;
    } | {
        status: 401;
    }>("/auth/user", {
        ...opts
    }));
}
/**
 * Generate Hubspot Identification Token
 */
export function generateHubspotIdentificationToken(hubspotIdentificationTokenGenerationRequest: HubspotIdentificationTokenGenerationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HubspotIdentificationToken;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>("/hubspot/token", oazapfts.json({
        ...opts,
        method: "POST",
        body: hubspotIdentificationTokenGenerationRequest
    })));
}
/**
 * Lookup Postal Code
 */
export function lookupPostalCode(country: SupportedCountriesEnum, q: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BringPostalCodeLookupResponse;
    } | {
        status: 401;
    } | {
        status: 422;
        data: HttpValidationError;
    }>(`/bring/lookup-postal-code${QS.query(QS.explode({
        country,
        q
    }))}`, {
        ...opts
    }));
}
/**
 * Get Status Message List
 */
export function getStatusMessageList(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: StatusMessageList;
    } | {
        status: 401;
    }>("/service/status-message/", {
        ...opts
    }));
}
